import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import * as config from '../../Config/environment.js';
import React,{useState} from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate,useParams } from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import Grid from '@mui/material/Grid';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ProgressBar } from 'primereact/progressbar';
import { Skeleton } from 'primereact/skeleton';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Tooltip } from 'primereact/tooltip';
import { Slider } from "primereact/slider";
import { Galleria } from 'primereact/galleria';
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import {Panel} from 'primereact/panel';

import 'moment/locale/pt-br';
// import moment from "moment";
import moment, { lang } from 'moment-business-days';


// Load Actions
import * as AppActions from '../../Store/Actions/App'
import * as OrderActions from '../../Store/Actions/Order'

import AboutUs from '../../Components/layout/AboutUs';
import ContactUs from '../../Components/layout/ContactUs';
import ExpireView from '../../Components/ExpireModal';

import iconResponsibleWarning from '../../Assets/Images/iconResponsibleWarn.svg';
import iconDownload from '../../Assets/Images/iconDownload.svg';
import iconSendEmail from '../../Assets/Images/iconSendEmail.svg';

// import Timer from '../../Components/Timer'; WEB WORKER FOR BACKGROUND TASK

// Load Componentes 
import AlertView from '../../Components/AlertModal';
import TermsView from '../../Components/TermsModal';

import {
	formatNumberCurrency,
    padronizarDecimal,
    maskCPF,
    validarCPF,
    validarEmail,
    validarTelefone,
    aplicarMascaraDataNascimento,
    maskPhone,
    getAgeCategory
} from '../../Components/Utils';
import { useEffect } from 'react';

// Set booking timer
var bookingTimer;

// export default function HomePage() {
const BookingDetails = (props) => {

const apiKey = 'AIzaSyBFNooJFvoHEGeQOJqUuekFHT1PRQ8TbCs';
	
// Set var from props
const {
	setDialog,
	dialog,
	currentAgency,
	searchParams,
	exchangeRates,
    selectedProperty,
    setSelectedProperty,
    downloadQuotePdf,
    retrievePersonInfoByDocument,
    createBooking,
    currentBooking,
    searchResultToken,
    checkSearchResult,
    paymentConfirmed
} = props;

const { id } = useParams();

const [propertyId, setPropertyId] = useState(null); 

const [creatingBooking, setCreatingBooking] = useState(false); 
const [loadingFiltering, setLoadingFiltering] = useState(false); 
const [loading, setLoading] = useState(true); 
const [saving, setSaving] = useState(false); 

const [contentLoaded, setContentLoaded] = useState(false); 
const [hostingOption, setHostingOptions] = useState(false); 
const [currentStep, setCurrentStep] = useState(1); // 1 continent - 2 country - 3 city  - 4 options

const [contentLoading, setContentLoading] = useState(true); 

const [currentContinent, setCurrentContinent] = useState({}); // id and label
const [currentCountry, setCurrentCountry] = useState({}); // id and label
const [currentCity, setCurrentCity] = useState({}); // id and label

const [breadcrumbArray, setBreadcrumbArray] = useState([]); // id and label
	
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

const [email, setEmail] = useState('');
const [password, setPassword] = useState('');
const [stillConnected, setStillConnected] = useState(false);
const onStillConnectedChange = (e) => {
	if (e.checked)
		setStillConnected(true);
	else
		setStillConnected(false);
}  // end function
	
// Alert control
const [alert, setAlert] = useState(false); 
const [alertTitle, setAlertTitle] = useState("Informações"); 
const [alertBody, setAlertBody] = useState("Conteúdo dinâmico"); 
const [alertAction, setAlertAction] = useState(""); 

// Expire Dialog control
const [alertExpire, setAlertExpire] = useState(false); 
const [alertTitleExpire, setAlertTitleExpire] = useState("Informações"); 
const [alertBodyExpire, setAlertBodyExpire] = useState("Conteúdo dinâmico"); 
const [alertActionExpire, setAlertActionExpire] = useState("restartSearch"); 

const [currentPlaces, setCurrentPlaces] = useState([]); 		

const [hostsAndRoomsLabel, setHostsAndRoomsLabel] = useState(null); 
const [hostsLabel, setHostsLabel] = useState(null); 
const [roomsLabel, setRoomsLabel] = useState(null); 
const [dateRangeDays, setDateRangeDays] = useState(null); 

const [hostsAndRooms, setHostsAndRooms] = useState(null); 
const [rooms, setRooms] = useState([{ adults: 2, children: [] }]); // Default at least 1 adult
const [selectedRooms, setSelectedRooms] = useState([]); // Default at least 1 adult

const [totalAmountPaidNow, setTotalAmountPaidNow] = useState(0.00); // Default at least 1 adult
const [totalAmount, setTotalAmount] = useState(0.00); // Default at least 1 adult
const [totalCollectedFeeAmount, setTotalCollectedFeeAmount] = useState(null); // Default at least 1 adult
const [currencyCollectedFeeAmount, setCurrencyCollectedFeeAmount] = useState(null); // Default at least 1 adult
const [totalAmountGrouped, setTotalAmountGrouped] = useState(""); // Default at least 1 adult
const [localCollectedFeeItems, setLocalCollectedFeeItems] = useState([]); // Default at least 1 adult

const [roomsButtonDisabled, setRoomsButtonDisabled] = useState(false); // Default at least 1 adult

/* Temporary used to set selected room guests */
const [selectedGuests, setSelectedGuests] = useState({adults:1,children:[]});
const [selectedChildAges, setSelectedChildAges] = useState([]);
const [availableChildAges, setAvailableChildAges] = useState([]);

const [availableChildren, setAvailableChildren] = useState([]);
const [availableAdults, setAvailableAdults] = useState([]);
const [remainingAdults, setRemainingAdults] = useState(0);
const [remainingChildren, setRemainingChildren] = useState([]);

const [imageWithError, setImageWithError] = useState(0);

const [dateRange, setDateRange] = useState([]); 
const [formattedValue, setFormattedValue] = useState('');

const prevDateRangeRef = React.useRef(null); // to save precvious dateRange before change

const [filterByCity, setFilterByCity] = useState(null); 
const [filterByCountry, setFilterByCountry] = useState(null); 

const [resultCard, setResultCard] = useState({});

/* Get out and get in to screen control.  */
const [lastHiddenTime, setLastHiddenTime] = React.useState(null);
const timeoutMinutes = config.BUSINESS_RULES.timeoutMinutes; // Tempo em minutos

// Exchange rate USD
const [usdExchangeRate, setUsdExchangeRate] = useState(null);
const [exchangeRateInitials, setExchangeRateInitial] = useState("USD");

// Booking details
const [responsibleDocumentType, setResponsibleDocumentType] = useState(false);
const [responsibleDocument, setResponsibleDocument] = useState("");
const [responsibleName, setResponsibleName] = useState("");
const [responsibleBirthDate, setResponsibleBirthDate] = useState("");
const [responsibleEmail, setResponsibleEmail] = useState("");
const [responsiblePhone, setResponsiblePhone] = useState(""); 
const [responsibleIsGuest, setResponsibleIsGuest] = useState(true);
const [responsibleManualEdit, setResponsibleManualEdit] = useState(false);
const [responsibleDataFetched, setResponsibleDataFetched] = useState({});
const [responsibleFetching, setResponsibleFetching] = useState(false);  

// console.log('[responsibleDataFetched]--------->]'+JSON.stringify(responsibleDataFetched, null, 2));

// Guests
const [hostsArray, setHostsArray] = useState([]); // Array to store hosts and children for forms
const [panelVisibility, setPanelVisibility] = useState({});
const [hostDocumentType, setHostDocumentType] = useState({});
const [hostNoCpf, setHostNoCpf] = useState({});
const [hostDocument, setHostDocument] = useState({});
const [hostName, setHostName] = useState({});
const [hostBirthdate, setHostBirthdate] = useState({});
const [hostDataFetched, setHostDataFetched] = useState({});
const [hostManualEdit, setHostManualEdit] = useState({});
const [hostFetching, setHostFetching] = useState({});  

 console.log('[hostDocumentType]--------->]'+JSON.stringify(hostDocumentType, null, 2));

// Room
const [roomAdditionalInfo, setRoomAdditionalInfo] = useState("");
const maxChars = 150;
const isLimitReached = roomAdditionalInfo.length === maxChars;

const [roomExtraInfo, setRoomExtraInfo] = useState("");
const [roomCancelPolicy, setRoomCancelPolicy] = useState("");

// Action buttons
const [loadingQuote, setLoadingQuote] = useState(false);
const [loadingSendEmail, setLoadingSendEmail] = useState(false);

// Collected Fees
const [collectedFeeDetails, setCollectedFeeDetails] = React.useState([]);
const [nonUsdFees, setNonUsdFees] = React.useState([]);

// Terms and Conditions
const [acceptTerm, setAcceptTerm] = React.useState(false);
const [termsModal, setTermsModal] = React.useState(false); 


const handleAdditionalInfoChange = (e) => {
    const value = e.target.value;
    if (value.length <= maxChars) {
        setRoomAdditionalInfo(value);
    }
};


const togglePanel = (index) => {
    setPanelVisibility((prev) => ({
        ...prev,
        [index]: !prev[index],
    }));
};

const handleHostDocumentTypeChange = (index, value) => {
    
    // Desliga o campo de "Sem CPF" se "Sou estrangeiro" for selecionado
    if (hostNoCpf[index]) {
        setHostNoCpf((prev) => ({
            ...prev,
            [index]: false,
        }));
    }

    setHostDocumentType((prev) => ({
        ...prev,
        [index]: value,
    }));

    setHostDocument((prev) => ({
        ...prev,
        [index]: "",
    }));
    setHostName((prev) => ({
        ...prev,
        [index]: "",
    }));
    setHostBirthdate((prev) => ({
        ...prev,
        [index]: "",
    }));
    

    if (value) {
        setHostManualEdit((prev) => ({
        ...prev,
        [index]: true,
    }));
    } else {
        setHostManualEdit((prev) => ({
        ...prev,
        [index]: false,
    }));
    }

};

const handleHostNoCpfChange = (index, value) => {
    
    // Desliga o campo de tipo de documento se "Sem CPF" for selecionado
    if (hostDocumentType[index]) {
        setHostDocumentType((prev) => ({
            ...prev,
            [index]: false,
        }));
    }

    setHostNoCpf((prev) => ({
        ...prev,
        [index]: value,
    }));

    setHostDocument((prev) => ({
        ...prev,
        [index]: "",
    }));
    setHostName((prev) => ({
        ...prev,
        [index]: "",
    }));
    setHostBirthdate((prev) => ({
        ...prev,
        [index]: "",
    }));
    

    if (value) {
        setHostManualEdit((prev) => ({
        ...prev,
        [index]: true,
    }));
    } else {
        setHostManualEdit((prev) => ({
        ...prev,
        [index]: false,
    }));
    }


};  

const handleHostDocumentChange = (index, value) => {
    setHostDocument((prev) => ({
        ...prev,
        [index]: value,
    }));
};  

const handleHostNameChange = (index, value) => {
    setHostName((prev) => ({
        ...prev,
        [index]: value,
    }));
};

const handleHostBirthdateChange = (index, value) => {
    setHostBirthdate((prev) => ({
        ...prev,
        [index]: value,
    }));
};  


const handleResponsibleDocumentType = (value) => {

    setResponsibleDocumentType(value);

    setResponsibleDocument("");
    setResponsibleName("");
    setResponsibleBirthDate("");
    setResponsibleEmail("");
    setResponsiblePhone("");    

    if (value) {
        setResponsibleManualEdit(true);
    } else {
        setResponsibleManualEdit(false);
    }

}  // end function


const handleTermsChange = (e) => {
	if (e.checked)
		setAcceptTerm(true);
	else
		setAcceptTerm(false);
}  // end function


const calcularIdade = (data,targetDate=null) => {
  if (!data) return '';

  // Tenta primeiro no formato DD/MM/YYYY
  let birth = moment(data, 'DD/MM/YYYY', true);

  // Se não for válido, tenta como data raw (pode ser ISO, timestamp, etc.)
  if (!birth.isValid()) {
    birth = moment(data);
  }

  if (!birth.isValid()) return '';

  // Return age     
  if (targetDate) {
    return moment(targetDate).diff(birth, 'years');
  } else {
    return moment().diff(birth, 'years');
  }

};

function calcularTotalTaxas(taxes) {

 if (!Array.isArray(taxes) || taxes.length === 0) {
    return 0; // Retorna 0 se não houver taxas
  }

  // Filtra apenas as taxas com relation = "included"
  const taxasIncluidas = taxes.filter(taxa => taxa.relation === "included");

  // Soma os valores do campo amount
  const total = taxasIncluidas.reduce((soma, taxa) => soma + taxa.amount, 0);

  return total;
}

function calcularTotalFees(taxes) {

 if (!Array.isArray(taxes) || taxes.length === 0) {
    return 0; // Retorna 0 se não houver taxas
  }

  // Filtra apenas as taxas com relation = "display"
  const taxasDisplay = taxes.filter(taxa => taxa.relation === "display");

  // Soma os valores do campo amount
  const total = taxasDisplay.reduce((soma, taxa) => soma + taxa.amount, 0);

  return total;
}

// useRef 
const toast = React.useRef(null);


// DEBUG
/*console.log('[rooms]----------> '+JSON.stringify(rooms,null,2));
console.log('availableChildren ----------------> '+JSON.stringify(availableChildren,null,2));
console.log('availableAdults ----------------> '+JSON.stringify(availableAdults,null,2));
console.log('[remainingAdults]----------> '+JSON.stringify(remainingAdults,null,2));
console.log('[remainingChildren]----------> '+JSON.stringify(remainingChildren,null,2));
console.log('[selectedGuests]----------> '+JSON.stringify(selectedGuests,null,2));
console.log('[selectedChildAges]----------> '+JSON.stringify(selectedChildAges,null,2));*/

// console.log('[searchFilters]----------------------> '+JSON.stringify(searchFilters,null,2));
//console.log('[resultCard]----------> '+JSON.stringify(resultCard,null,2)); 
// console.log('[resultsRooms]----------> '+JSON.stringify(resultsRooms,null,2)); 

// useEffect

/*
console.log('[selectedProperty]--------->]'+JSON.stringify(selectedProperty, null, 2));
console.log('[localCollectedFeeItems]--------->]'+JSON.stringify(localCollectedFeeItems, null, 2));
console.log('[totalAmount]--------->]'+JSON.stringify(totalAmount, null, 2));
console.log('[totalAmountPaidNow]--------->]'+JSON.stringify(totalAmountPaidNow, null, 2));
console.log('[totalAmountPaidNow]--------->]'+JSON.stringify(totalAmountPaidNow, null, 2));
console.log('[totalAmountPaidNow]--------->]'+JSON.stringify(totalAmountPaidNow, null, 2));


console.log('[responsibleDocumentType]--------->]'+JSON.stringify(responsibleDocumentType, null, 2));
console.log('[responsibleDocument]--------->]'+JSON.stringify(responsibleDocument, null, 2));
console.log('[responsibleName]--------->]'+JSON.stringify(responsibleName, null, 2));
console.log('[responsibleBirthDate]--------->]'+JSON.stringify(responsibleBirthDate, null, 2));
console.log('[responsibleEmail]--------->]'+JSON.stringify(responsibleEmail, null, 2));
console.log('[responsiblePhone]--------->]'+JSON.stringify(responsiblePhone, null, 2));
console.log('[responsibleIsGuest]--------->]'+JSON.stringify(responsibleIsGuest, null, 2));
console.log('[responsibleDataFetched]--------->]'+JSON.stringify(responsibleDataFetched, null, 2));

console.log('[hostsArray]--------->]'+JSON.stringify(hostsArray, null, 2));
console.log('[hostDocumentType]--------->]'+JSON.stringify(hostDocumentType, null, 2));
console.log('[hostNoCpf]--------->]'+JSON.stringify(hostNoCpf, null, 2));
console.log('[hostDocument]--------->]'+JSON.stringify(hostDocument, null, 2));
console.log('[hostName]--------->]'+JSON.stringify(hostName, null, 2));
console.log('[hostBirthdate]--------->]'+JSON.stringify(hostBirthdate, null, 2));
console.log('[hostDataFetched]--------->]'+JSON.stringify(hostDataFetched, null, 2));
*/


/* Activate Success Toast  */
const showSuccess = (title="",message="") => {
    toast.current.show({severity:'success', summary: title, detail:message, life: 6000});
}


// Configurar feriados nacionais e municipais do Rio de Janeiro
moment.updateLocale('pt-br', {
    holidays: config.BUSINESS_RULES.holidays,
    holidayFormat: 'YYYY-MM-DD'
});

const geocodeAddress = async (address) => {
    const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`);
    const data = await response.json();
    if (data.status === 'OK') {
        const { lat, lng } = data.results[0].geometry.location;
        return { lat, lng };
    } else {
        throw new Error('Geocoding API error: ' + data.status);
    }
};	

const extractAllHosts = (rooms, type) => { 
    const adultCount = rooms.reduce((acc, room) => acc + room.adults, 0);
    const childCount = rooms.reduce((acc, room) => acc + room.children.length, 0);

    // Corrigindo a extração das crianças
    const childrenArray = rooms.flatMap(room => room.children);

    const adultLabel = adultCount > 1 ? 'adultos' : 'adulto';
    const childLabel = childCount > 1 ? 'crianças' : 'criança';

    const parts = [];
    const hostsArray = {}; // Corrigindo para um objeto

    if (adultCount > 0) {
        parts.push(`${adultCount} ${adultLabel}`);
        hostsArray.adults = adultCount; // Usando objeto corretamente
    }
    if (childCount > 0) {
        parts.push(`${childCount} ${childLabel}`);
        hostsArray.children = childrenArray; // Agora armazenará corretamente todas as crianças
    }

    return type === 'label' ? parts.join(', ') : hostsArray;	
};

const handleClickScroll = (target,displacement=70) => {
		
	const element = document.getElementById(target);
	if (element) {
		// 👇 Will scroll smoothly to the top of the next section
		var elementPosition = element.offsetTop - displacement;
		element.scrollIntoView({ top: elementPosition,behavior: 'smooth' });
	}
};  


React.useEffect(() => {
	if (!hostsAndRooms) {
		setHostsAndRooms(null);
	}	
}, [hostsAndRooms]);

React.useEffect(() => {
	if (dateRange && dateRange[0] && dateRange[1]) {
		const diffTime = Math.abs(dateRange[1] - dateRange[0]);
		const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
		const formattedRange = formatDateRange(dateRange);
		let nightLabel = diffDays == 1 ? "noite" : "noites";
		setFormattedValue(`${formattedRange} (${diffDays} ${nightLabel})`);
	} else {
		setFormattedValue('');
	}
}, [dateRange]);

const formatDateRange = (range) => {
	if (range && range[0] && range[1]) {
		const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
		return `${range[0].toLocaleDateString('pt-BR', options)} - ${range[1].toLocaleDateString('pt-BR', options)}`;
	}
	return '';
};
  

  // Função que será chamada ao retornar após X minutos
  const handleReturnAfterTimeout = () => {

    // Prepare props and data
    var props = {
        setAlertExpire:setAlertExpire,
        setAlertTitleExpire:setAlertTitleExpire,
        setAlertBodyExpire:setAlertBodyExpire,
        setAlertActionExpire:setAlertActionExpire,
    }
    var data = {
        searchResultToken:searchResultToken
    }	
    checkSearchResult(data,props);

};

React.useEffect(() => {
const handleVisibilityChange = () => {
  if (document.visibilityState === "hidden") {
    // Quando a aba fica inativa, salva o tempo atual
    setLastHiddenTime(Date.now());
  } else if (document.visibilityState === "visible") {
    // Quando a aba volta a ficar ativa
    if (lastHiddenTime) {
      const elapsedMinutes = (Date.now() - lastHiddenTime) / (1000 * 60); // Calcula o tempo em minutos
      if (elapsedMinutes >= timeoutMinutes) {
        handleReturnAfterTimeout();
      }
    }
    setLastHiddenTime(null); // Reseta o último tempo ao retornar
  }
};

// Adiciona o listener para detectar mudança de visibilidade
document.addEventListener("visibilitychange", handleVisibilityChange);

return () => {
  // Remove o listener ao desmontar o componente
  document.removeEventListener("visibilitychange", handleVisibilityChange);
};
}, [lastHiddenTime]);


// Set calendar locale
addLocale('br', {
	firstDayOfWeek: 1,
	dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
	dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
	monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	today: 'Hoje',
	clear: 'Limpar'
});


// set Use of history for PUSH 
var navigate = useNavigate();

// Reload Controls, breadcrumb and map elements
const loadInterfaceElements = (searchFiltersArray=null) => {

      // Set date range and rooms
      setDateRange(searchFiltersArray ? searchFiltersArray.dateRange : searchParams.dateRange);
      setDateRangeDays(searchFiltersArray ? searchFiltersArray.dateRangeDays : searchParams.dateRangeDays);
      setRooms(searchFiltersArray ? searchFiltersArray.rooms : searchParams.rooms);	

}

// Runs when opens component
React.useEffect(() => {

	// Retrieve User Data Obj. 
	var result = localStorage.getItem("@dream4/userData", undefined,true);
	var userData = JSON.parse(result);  

	  // If token dont exist, redirect to onboarding or register
	  if (!userData) {
		  navigate("/home");
		  return;
	  } // end if

	  // If order toek ins NULL, REDIRECT to /order
	  if (!searchResultToken) {

		// Reset local storage control
		// ...

		navigate("/order");
		return;
	  }      
	  
  // set scroll to top
  window.scrollTo(0, 1);


  // Simulate loading off
  setTimeout(() => {
    setContentLoading(false);
  }, 1000);

  // reset loading
  setCreatingBooking(false);

// Set USD exchange Rate and currency initials
if (searchParams?.country?.code == "BR") {
    const result = exchangeRates.find(item => item.targetCurrencyInitials === "USD");
    const exchangeRateValue = result.value;
    setUsdExchangeRate(exchangeRateValue); 
    setExchangeRateInitial("BRL"); 
}  

  // Load Interface elements
  loadInterfaceElements(); 

    
  // Runs when UNMOUNT component
  return () => {

	setContentLoading(true); 
	setContentLoaded(false); 
	setHostingOptions(false); 
	setCurrentStep(1); 

	setCurrentContinent({}); 
	setCurrentCountry({}); 
	setCurrentCity({}); 
	setBreadcrumbArray([]); 

	setCurrentPlaces([]); 		
	setHostsAndRooms(null); 
	setRooms([{ adults: 2, children: [] }]); 
		
	setDateRange(null); 
	setFormattedValue('');
		
	setFilterByCity(null); 
	setFilterByCountry(null); 	

    setImageWithError(0);

    setCreatingBooking(false);
	
  };
  
}, []); // end useEffect 


React.useEffect(() => {

    if (currentBooking.property) {
        console.log('[CURRENT BOOKING EXISTS]--------->]');

        if (paymentConfirmed) {
            navigate("/order/hotel/booking/payment");
        } else {
            navigate("/order/hotel/booking/confirm");
        }

    } // if
    else {
        console.log('[CURRENT BOOKING DOES NOT EXIST]--------->]');
    }

}, [navigate]);


React.useEffect(() => {
    // Calcula a soma total antes de atualizar o estado
    const total = selectedProperty?.room?.reduce((sum, item) => sum + (item.updatedPriceWithMarkup ? item.updatedPriceWithMarkup : item.totalWithMarkup), 0);

    // Set total amount paid now
    setTotalAmountPaidNow(total);

    const feesByCurrency = {};

    selectedProperty?.room?.forEach(item => {
        let fees = [];

        // Caso array direto
        if (Array.isArray(item.localCollectedFee)) {
            fees = item.localCollectedFee;
        }
        // Caso objeto com fees
        else if (item.localCollectedFee && Array.isArray(item.localCollectedFee.fees)) {
            fees = item.localCollectedFee.fees;
        }

        fees.forEach(fee => {
            if (fee.relation === "display" || fee.relation === undefined) {
                const feeCurrency = fee.currency;
                if (!feesByCurrency[feeCurrency]) {
                    feesByCurrency[feeCurrency] = 0;
                }
                feesByCurrency[feeCurrency] += fee.total || 0;
            }
        });
    });

    const usdFee = feesByCurrency["USD"] || 0;
    let grandTotal = total + usdFee;
    setTotalAmount(grandTotal);

    // Fees não-USD para Total
    const nonUsd = Object.entries(feesByCurrency)
        .filter(([currency]) => currency !== "USD")
        .map(([currency, total]) => ({ currency, total }));
    setNonUsdFees(nonUsd);

    // Para "Pagar na propriedade"
    const feeCurrencies = Object.keys(feesByCurrency);

    let payAtPropertyDetails = [];
    if (feeCurrencies.length === 1) {
        const singleCurrency = feeCurrencies[0];
        payAtPropertyDetails = [{
            currency: singleCurrency,
            total: feesByCurrency[singleCurrency],
        }];
    } else {
        payAtPropertyDetails = Object.entries(feesByCurrency).map(([currency, total]) => ({
            currency,
            total
        }));
    }

    setCollectedFeeDetails(payAtPropertyDetails);

    // Prepara array de hosts para forms
    let hostsArray = [];
    let currentIndex = 0;
    const room = selectedProperty?.hostsAndRoomsArray || [];
    const hostsAdults = room?.adults || 0;
    const childrenArr = Array.isArray(room?.children) ? room.children : [];
    const hostsChildren = childrenArr.length;

    for (let i = 0; i < hostsAdults; i++) {
        hostsArray.push({ type: 'adult', index: currentIndex });
        currentIndex++;
    }
    for (let i = 0; i < hostsChildren; i++) {
        hostsArray.push({ type: 'child', age: childrenArr[i].age || 0, index: currentIndex });
        currentIndex++;
    }
    setHostsArray(hostsArray);

    // Set label agrupado
    if (nonUsd.length > 0) {
        const formattedNonUsd = nonUsd.map(fee => `${formatNumberCurrency(fee.total, fee.currency)}`).join(" + ");
        setTotalAmountGrouped(`${formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)} + ${formattedNonUsd}`);
    } else {
        setTotalAmountGrouped(formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials));
    }

    // Set labels
    selectedProperty?.room?.map((item, index) => {
        const valueAdds = item.valueAdds ? item.valueAdds?.["value-add"] : item?.["value-adds"]?.["value-add"];

        const hasCode = (code) => {
            if (!valueAdds) return false;
            if (Array.isArray(valueAdds)) {
                return valueAdds.some((valueAdd) => valueAdd.code === code);
            }
            return valueAdds.code === code;
        };

        if (selectedProperty.origin == "hyperguest") {
            const daysBefore = item.cancellationPolicies?.[0]?.daysBefore || 0;
            const cancellationDeadline = moment(dateRange[0]).businessSubtract(daysBefore, 'days').format('YYYY-MM-DD')
            item['cancellation-deadline'] = cancellationDeadline;
        }

        const hasFreeCancellation = item['cancellation-deadline'] ? item['cancellation-deadline'] : false;
        const hasFreeBreakfast = hasCode("free_breakfast");

        setRoomExtraInfo(hasFreeBreakfast ? "Café da manhã incluído" : "Nenhuma opção extra");
        setRoomCancelPolicy(hasFreeCancellation ? `Cancelamento Gratuito até ${moment(item['cancellation-deadline']).businessSubtract(2, 'days').format('DD/MM/YYYY')}` : "Nenhuma opção de cancelamento");

        const rawFee = item?.localCollectedFee?.fees || item?.localCollectedFee;
        const localCollectedFee = Array.isArray(rawFee) ? rawFee.filter(f => f?.relation === 'display' || f?.relation === undefined) : rawFee;
        setLocalCollectedFeeItems(localCollectedFee || []);
    });

}, [selectedProperty]);


/* confirm booking prompt START  */
const accept = (e) => {
    proceedToBookingConfirm();
};

const reject = (e) => {
    //op.current.toggle(e);
};

const confirm = (event) => {
    confirmPopup({
        target: event.currentTarget,
        message: <div>Tem certeza que deseja <br /> finalizar a reserva?</div>,
        icon: 'pi pi-exclamation-triangle',
        accept,
        reject,
        rejectLabel:"Não, vou revisar",
        acceptLabel:"Sim, prosseguir!"
    });
};
/* confirm booking prompt END  */

/* Function to fetch host data by document */
const fetchHostData = async (index) => {

    try {
        let documentValue = "";
        let isResponsible = false;

        // Detectar se é para responsável ou host
        if (index === "responsibleDocument") {
            documentValue = responsibleDocument.replace(/\D/g, '');
            isResponsible = true;
        } else {
            documentValue = hostDocument[index].replace(/\D/g, '');
        }

        // Validar se CPF foi preenchido e é válido
        if (!documentValue || documentValue.length !== 11 || !validarCPF(documentValue)) {
            toast.current.show({
                severity: 'warn',
                summary: "Atenção",
                detail: "CPF inválido ou incompleto. Verifique e ajuste antes de buscar.",
                life: 5000
            });
            return;
        }

        // Turn on loading state
        if (isResponsible) {
            setResponsibleFetching(true);
        } else {
            setHostFetching((prev) => ({ ...prev, [index]: true }));
        }

        // Chama action para buscar dados
        const result = await retrievePersonInfoByDocument({ personDocument: documentValue });

        // Turn off loading state
        if (isResponsible) {
            setResponsibleFetching(false);
        } else {
            setHostFetching((prev) => ({ ...prev, [index]: false }));
        }        

        if (result.success) {

            const name = result.personData.nome || '';
            const birthdate = result.personData.nascimento || '';

            const formattedBirth = birthdate ? birthdate.split("-").reverse().join("/") : "";

            if (isResponsible) {
                setResponsibleName(name);
                setResponsibleBirthDate(formattedBirth);
                setResponsibleDataFetched(result.personData);
            } else {
                setHostName((prev) => ({ ...prev, [index]: name }));
                setHostBirthdate((prev) => ({ ...prev, [index]: formattedBirth }));
                setHostDataFetched((prev) => ({ ...prev, [index]: result.personData }));
            }

            // Check if all data returned. If not, release manual edition.
            if (isResponsible) {
                if (!name || !formattedBirth) {
                    setResponsibleManualEdit(true);
                }
            } else {
                if (!name || !formattedBirth) {
                    setHostManualEdit((prev) => ({ ...prev, [index]: true }));
                }
            }
            
        } else {

            toast.current.show({
                severity: 'warn',
                summary: "Erro",
                detail: result.errorMessage || "Erro ao buscar dados do CPF. Tente novamente e caso não retorne, preencha o nome e data de nascimento manualmente.",
                life: 10000
            });

            // Check if all data returned. If not, release manual edition.
            if (isResponsible) {                
                setResponsibleManualEdit(true);
            } else {
                setHostManualEdit((prev) => ({ ...prev, [index]: true }));
            }

        }
    } catch (error) {

        // Turn off loading state
        if (index === "responsibleDocument") {
            setResponsibleFetching(false);
            setResponsibleManualEdit(true);
        } else {
            setHostFetching((prev) => ({ ...prev, [index]: false }));
            setHostManualEdit((prev) => ({ ...prev, [index]: true }));
        }

        toast.current.show({
            severity: 'error',
            summary: "Erro",
            detail: error.message || "Erro ao buscar dados do CPF. Tente novamente e caso não retorne, preencha o nome e data de nascimento manualmente pois os campos foram liberados para edição.",
            life: 10000
        });

    }
};


// Function to proceed to booking confirmation
// This function will be called when the user clicks on the "Proceed to Booking" button
const proceedToBookingConfirm = async () => {

    // 1 >>> Verificar se responsável está preenchido e válido
    if (!responsibleName || !responsibleBirthDate || !responsibleDocument || !responsibleEmail || !responsiblePhone) {
        setAlertTitle("Atenção");
        setAlertBody("Por favor, preencha todos os dados do responsável pelo pagamento da reserva.");
        setAlert(true);
        return;
    }

    // Validar CPF do responsável se aplicável
    if (!responsibleDocumentType && !validarCPF(responsibleDocument)) {
        setAlertTitle("Atenção");
        setAlertBody("O CPF do responsável pela reserva está inválido.");
        setAlert(true);
        return;
    }

    // 2 >>> Verificar se dados dos hóspedes estão preenchidos e válidos
    let hasError = false;
    hostsArray.forEach(host => {
        const index = host.index;

        // Se for criança, validar idade informada com data de nascimento
        if (host.type === 'child') {
            const idadeCalculada = calcularIdade(hostBirthdate[index]);
            if (idadeCalculada !== host.age) {
              setAlertTitle("Atenção");
              setAlertBody(`A idade informada para a criança (hóspede ${index + 1}) não corresponde à data de nascimento. Por favor, verifique os dados informados. Se for o caso, faça nova busca informando a idade correta.`);
              setAlert(true);
              hasError = true;
              return;
            }
        }

        // >>> NOVA VERIFICAÇÃO PARA ADULT <<<
        if (host.type === 'adult') {
            const idadeCalculada = calcularIdade(hostBirthdate[index]);
            if (idadeCalculada < 18) {
                setAlertTitle("Atenção");
                setAlertBody(`O hóspede ${index + 1} está definido como adulto, mas tem idade inferior a 18 anos. Verifique os dados informados.`);
                setAlert(true);
                hasError = true;
                return;
            }
        }        

        // Verifica campos obrigatórios
        if (!hostName[index] || !hostBirthdate[index] || (!hostNoCpf[index] && !hostDocument[index])) {
            setAlertTitle("Atenção");
            setAlertBody(`Por favor, preencha todos os dados obrigatórios do hóspede ${index + 1}.`);
            setAlert(true);
            hasError = true;
            return;
        }

        // Se não for estrangeiro nem "sem CPF", validar CPF
        if (!hostDocumentType[index] && !hostNoCpf[index] && !validarCPF(hostDocument[index])) {
            setAlertTitle("Atenção");
            setAlertBody(`O CPF informado para o hóspede ${index + 1} é inválido.`);
            setAlert(true);
            hasError = true;
            return;
        }
    });

    if (hasError) return;

    // >>> Verificar se existem documentos duplicados <<<
    const documentosValidos = Object.values(hostDocument).filter((doc, idx) => !hostNoCpf[idx] && doc);
    const documentosDuplicados = documentosValidos.filter((doc, index, self) => self.indexOf(doc) !== index);

    if (documentosDuplicados.length > 0) {
        setAlertTitle("Atenção");
        setAlertBody("Existe(m) documento(s) repetido(s) entre os hóspedes. Verifique os dados informados.");
        setAlert(true);
        return;
    }    

    // 2.2 >>> Se "Responsável é um dos hóspedes", verificar se o documento bate
    if (responsibleIsGuest) {
        const isMatch = Object.values(hostDocument).some(doc => doc === responsibleDocument);
        if (!isMatch) {
            setAlertTitle("Atenção");
            setAlertBody("O responsável pelo pagamento não corresponde a nenhum dos hóspedes. Verifique os dados informados e certifique-se que o CPF ou Número do passaporte estejam idênticos.");
            setAlert(true);
            return;
        }
    }

    // 3 >>> Verificar aceite dos termos
    if (!acceptTerm) {
        setAlertTitle("Atenção");
        setAlertBody("É necessário aceitar os termos e condições para prosseguir com a reserva.");
        setAlert(true);
        return;
    }


    // Preparar dados para criação da reserva - setting calculates or derived values

    // Função para verificar se um código específico está presente
    const extractNames = (completeName) => {
        if (!completeName) return { firstName: "", lastName: "" };
        const parts = completeName.trim().split(/\s+/);
        const firstName = parts[0] ?? "";
        const lastName = parts.length > 1 ? parts[parts.length - 1] : "";
        return { firstName, lastName };
    }  
    const responsibleNames = extractNames(responsibleName ?? "");

    const extractGender = (hostData,index) => {
        if (!hostData || !hostData[index]) return null;
        const host = hostData[index];
        if (!host || !host.genero) return null;
        return host.genero;
    };
    
    const hasCode = (code,valueAdds) => {
        if (!valueAdds) return false;

        // Verifica se é um array
        if (Array.isArray(valueAdds)) {
        return valueAdds.some((valueAdd) => valueAdd.code === code);
        }

        // Caso seja um objeto único
        return valueAdds.code === code;
    };    
    const valueAddList = selectedProperty?.room?.[0]?.valueAdds?.["value-add"];

    const valueAddArray = Array.isArray(valueAddList) ? valueAddList : valueAddList ? [valueAddList] : [];

    //const valueAdds = valueAddArray.map(x => x.name).join(", ") || "Nenhum extra selecionado";
    const extra = hasCode("free_breakfast", valueAddArray) ? "Café da manhã incluído" : "Nenhuma opção extra";

    // Montagem do bookingData
    const bookingData = {
        bookingInfo: {
            hostingServiceId: selectedProperty?.property?.origin == 'priceline' ? selectedProperty?.property?.pricelineProvider?.id : (selectedProperty?.property?.hyperguestProvider?.id || null),
            hostingServiceName: selectedProperty?.property?.origin == 'priceline' ? selectedProperty?.property?.pricelineProvider?.code : (selectedProperty?.property?.hyperguestProvider?.code || null),
            propertyId: selectedProperty?.property?.property_id ?? null,
            itemId: String(selectedProperty?.property?.id) ?? null,
            checkinDate: moment(selectedProperty?.dateRange?.[0]).format("YYYY-MM-DD"),
            checkoutDate: moment(selectedProperty?.dateRange?.[1]).format("YYYY-MM-DD"),
            nightsStay: selectedProperty?.dateRangeDays ?? 1,
            country: selectedProperty?.property?.country ?? "Não definido",
            city: selectedProperty?.property?.city ??  "Não definido",
            countryPT: selectedProperty?.property?.countryPT ?? null,
            cityPT: selectedProperty?.property?.cityPT ??  null,
            propertyCancellationPolicy: selectedProperty?.room?.[0]?.['cancellation-policy'] ?? null,
            propertyCancellationDeadline: selectedProperty?.room?.[0]?.['cancellation-deadline'] ?? "Não definido",
            selectedAgency: currentAgency?.agencyCode ? currentAgency : null,
            cancellationDeadline: selectedProperty?.room?.[0]?.['cancellation-deadline'] ? moment(selectedProperty?.room?.[0]?.['cancellation-deadline']).businessSubtract(2, 'days').format('YYYY-MM-DD') : "Não definido",
            hasChallenger: selectedProperty?.hasChallenger ?? false,
            challenger: {
                winnerHostingService: "Não definido",
                winnerPropertyName: "Não definido",
                winnerPropertyId: "Não definido" 
            }
        },
        bookingPaymentResponsible: {
            isHost: responsibleIsGuest == true ? 1 : 0,
            isForeigner: responsibleDocumentType === true ? 1 : 0,
            document: responsibleDocument ?? "",
            completeName: responsibleName ?? "",
            firstName: responsibleNames.firstName || "Não definido",
            lastName: responsibleNames.lastName || "Não definido",
            birthDate: responsibleBirthDate?.split("/")?.reverse()?.join("-") ?? "",
            email: responsibleEmail ?? "",
            mobilePhone: responsiblePhone ?? ""
        },
        bookingHosts: hostsArray.map((host) => {            
            const completeName = hostName[host.index] ?? "";
            const { firstName, lastName } = extractNames(completeName);
            const gender = extractGender(hostDataFetched, host.index);
            const birthday = hostBirthdate[host.index].split("/").reverse().join("-") ?? "";

            return ({
                isForeigner: hostDocumentType[host.index] === true ? 1 : 0,
                dontHaveMainDocument: hostNoCpf[host.index] === true ? 1 : 0,
                document: hostDocument[host.index] ?? "",
                completeName: hostName[host.index] ?? "",
                firstName: firstName || "Não definido",
                lastName: lastName || "Não definido",
                birthDate: birthday ?? "",
                type: host.type ?? "adult",
                ageOnBookingDate: birthday ? calcularIdade(birthday,selectedProperty?.dateRange?.[1]) : null,
                ageRange: getAgeCategory(birthday) ?? null,
                gender: gender ?? null
            });
        }),
        bookingRoomsHostsQuantity: {
            rooms: selectedProperty?.hostsAndRoomsArray?.rooms ?? 1,
            adults: selectedProperty?.hostsAndRoomsArray?.adults ?? 1,
            child: selectedProperty?.hostsAndRoomsArray?.children?.length ?? 0,
            childAges: selectedProperty?.hostsAndRoomsArray?.children?.map(child => child.age) ?? []
        },
        bookingVoucherInfo: generateVoucherInfo()
    };


    if (selectedProperty?.property?.origin == 'priceline') {

            bookingData.bookingInfo.room = {
                title: selectedProperty?.room?.[0]?.room?.title ?? "Não definido",
                roomId: String(selectedProperty?.room?.[0]?.room?.["room-id"]) ?? null,
                roomRatePlan: selectedProperty?.room?.[0]?.["rate-plan-code"] ?? "Não definido",
                roomRateType: selectedProperty?.room?.[0]?.ratePlanType ?? "Não definido",
                netTotalPrice: selectedProperty?.room?.[0]?.bookingPricing?.total ?? null,
                netSubtotalPrice: selectedProperty?.room?.[0]?.bookingPricing?.subtotal ?? null,
                netPriceCurrency: selectedProperty?.room?.[0]?.bookingPricing?.currency ?? "USD",
                priceWithMarkup: String(selectedProperty?.room?.[0]?.totalWithMarkup) ?? null,
                netTax: selectedProperty?.room?.[0]?.bookingPricing?.taxes ?? null,
                netFee: selectedProperty?.room?.[0]?.bookingPricing?.fees ?? null,
                collectedFees: selectedProperty?.room?.[0]?.localCollectedFee?.fees?.map(fee => ({
                    description: fee.name ?? "Não definido",
                    amount: fee.total ?? 0,
                    currency: fee.currency ?? "Não definido"
                })) ?? [],
                roomCancellationPolicy: selectedProperty?.room?.[0]?.['cancellation-policy'] ?? null,
                roomPropertyCancellationDeadline: selectedProperty?.room?.[0]?.['cancellation-deadline'] ?? "Não definido",
                roomCancellationDeadline: selectedProperty?.room?.[0]?.['cancellation-deadline'] ? moment(selectedProperty?.room?.[0]?.['cancellation-deadline']).businessSubtract(2, 'days').format('YYYY-MM-DD') : "Não definido",
                policyDescription: selectedProperty?.room?.[0]?.['policy-description'] ?? null,
                extras: extra ?? null,
                additionalRequirements: roomAdditionalInfo ?? null
            };

             bookingData.bookingInfo.totals = {
                netTotalPrice: selectedProperty?.room?.[0]?.bookingPricing?.total ?? null,
                netSubtotalPrice: selectedProperty?.room?.[0]?.bookingPricing?.subtotal ?? null,
                netPriceCurrency: selectedProperty?.room?.[0]?.bookingPricing?.currency ?? "USD",
                priceWithMarkup: String(selectedProperty?.room?.[0]?.totalWithMarkup) ?? null,
                netTax: selectedProperty?.room?.[0]?.bookingPricing?.taxes ?? null,
                netFee: selectedProperty?.room?.[0]?.bookingPricing?.fees ?? null,
                collectedFees: selectedProperty?.room?.[0]?.localCollectedFee?.fees?.map(fee => ({
                    description: fee.name ?? "Não definido",
                    amount: fee.total ?? 0,
                    currency: fee.currency ?? "Não definido"
                })) ?? [],
            };

    }  // end if
    else if (selectedProperty?.property?.origin == 'hyperguest') {

            const taxes = calcularTotalTaxas(selectedProperty?.room?.[0]?.bookingPricing?.taxes ?? []);
            const total = selectedProperty?.room?.[0]?.bookingPricing?.net?.price ?? 0;
            const subtotal = total - taxes;
            const fees = calcularTotalFees(selectedProperty?.room?.[0]?.bookingPricing?.fees ?? []);
/*  "room": [
    {
      "hotelId": 19912,
      "hotelName": "Certification Property",
      "roomId": 31447,
      "roomName": "Double room",
      "roomCode": "DBL",
      "numberOfAvailableRooms": 1023,
      "ratePlanId": 865905,
      "ratePlanCode": "FLEX-BB",
      "ratePlanName": "Flex - Bed and Breakfast",
      "board": "BB",
      "cancellationPolicies": [*/

            bookingData.bookingInfo.room = {
                title: selectedProperty?.room?.[0]?.room?.title ?? "Não definido",
                roomId: String(selectedProperty?.room?.[0]?.room?.["room-id"]) ?? null,
                roomCode: selectedProperty?.room?.[0]?.["roomCode"] ?? "Não definido",
                roomRatePlan: selectedProperty?.room?.[0]?.["ratePlanCode"] ?? "Não definido",
                roomRateType: selectedProperty?.room?.[0]?.ratePlanType ?? "Não definido",
                netTotalPrice: total ?? null,
                netSubtotalPrice: Number(subtotal.toFixed(2)) ?? null,
                netPriceCurrency: selectedProperty?.room?.[0]?.bookingPricing?.net?.currency ?? "USD",
                priceWithMarkup: String(selectedProperty?.room?.[0]?.totalWithMarkup) ?? null,
                netTax: taxes ?? null,
                netFee: fees ?? null,
                collectedFees: selectedProperty?.room?.[0]?.localCollectedFee?.fees
                ?.filter(fee => fee.relation === "display")
                ?.map(fee => ({
                    description: fee.name ?? "Não definido",
                    amount: fee.total ?? 0,
                    currency: fee.currency ?? "Não definido"
                })) ?? [],
                roomCancellationPolicy: selectedProperty?.room?.[0]?.['cancellation-policy'] ?? null,
                roomPropertyCancellationDeadline: selectedProperty?.room?.[0]?.['cancellation-deadline'] ?? "Não definido",
                roomCancellationDeadline: selectedProperty?.room?.[0]?.['cancellation-deadline'] ? moment(selectedProperty?.room?.[0]?.['cancellation-deadline']).businessSubtract(2, 'days').format('YYYY-MM-DD') : "Não definido",
                policyDescription: selectedProperty?.room?.[0]?.['policy-description'] ?? null,
                extras: extra ?? null,
                additionalRequirements: roomAdditionalInfo ?? null
            };

             bookingData.bookingInfo.totals = {
                netTotalPrice: total ?? null,
                netSubtotalPrice: Number(subtotal.toFixed(2)) ?? null,
                netPriceCurrency: selectedProperty?.room?.[0]?.bookingPricing?.net?.currency ?? "USD",
                priceWithMarkup: String(selectedProperty?.room?.[0]?.totalWithMarkup) ?? null,
                netTax: taxes ?? null,
                netFee: fees ?? null,
                collectedFees: selectedProperty?.room?.[0]?.localCollectedFee?.fees
                ?.filter(fee => fee.relation === "display")
                ?.map(fee => ({
                    description: fee.name ?? "Não definido",
                    amount: fee.total ?? 0,
                    currency: fee.currency ?? "Não definido"
                })) ?? [],
            };


    } // end else if


/*
console.log('[responsibleIsGuest]--------->]'+JSON.stringify(responsibleIsGuest, null, 2));
console.log('[responsibleDocumentType]--------->]'+JSON.stringify(responsibleDocumentType, null, 2));

console.log('[bookingData]--------->]'+JSON.stringify(bookingData, null, 2));

// console.log('[selectedProperty]--------->]'+JSON.stringify(selectedProperty, null, 2));

// Turn on loading
setCreatingBooking(true);

setTimeout(() => {
    setCreatingBooking(false);
}, 3000);

return;*/


/*console.log('[selectedProperty]--------->]'+JSON.stringify(selectedProperty, null, 2));

console.log('[localCollectedFeeItems]--------->]'+JSON.stringify(localCollectedFeeItems, null, 2));
console.log('[totalAmount]--------->]'+JSON.stringify(totalAmount, null, 2));
console.log('[totalAmountPaidNow]--------->]'+JSON.stringify(totalAmountPaidNow, null, 2));
console.log('[totalAmountPaidNow]--------->]'+JSON.stringify(totalAmountPaidNow, null, 2));
console.log('[totalAmountPaidNow]--------->]'+JSON.stringify(totalAmountPaidNow, null, 2));


console.log('[responsibleDocumentType]--------->]'+JSON.stringify(responsibleDocumentType, null, 2));
console.log('[responsibleDocument]--------->]'+JSON.stringify(responsibleDocument, null, 2));
console.log('[responsibleName]--------->]'+JSON.stringify(responsibleName, null, 2));
console.log('[responsibleBirthDate]--------->]'+JSON.stringify(responsibleBirthDate, null, 2));
console.log('[responsibleEmail]--------->]'+JSON.stringify(responsibleEmail, null, 2));
console.log('[responsiblePhone]--------->]'+JSON.stringify(responsiblePhone, null, 2));
console.log('[responsibleIsGuest]--------->]'+JSON.stringify(responsibleIsGuest, null, 2));
console.log('[responsibleDataFetched]--------->]'+JSON.stringify(responsibleDataFetched, null, 2));

console.log('[hostsArray]--------->]'+JSON.stringify(hostsArray, null, 2));
console.log('[hostDocumentType]--------->]'+JSON.stringify(hostDocumentType, null, 2));
console.log('[hostNoCpf]--------->]'+JSON.stringify(hostNoCpf, null, 2));
console.log('[hostDocument]--------->]'+JSON.stringify(hostDocument, null, 2));
console.log('[hostName]--------->]'+JSON.stringify(hostName, null, 2));
console.log('[hostBirthdate]--------->]'+JSON.stringify(hostBirthdate, null, 2));
console.log('[hostDataFetched]--------->]'+JSON.stringify(hostDataFetched, null, 2));
*/

//console.log('[bookingData]--------->]'+JSON.stringify(bookingData, null, 2));

// Turn on loading
setCreatingBooking(true);

// Chama action
const result = await createBooking(bookingData, 45000);

    if (result.success) {

        // Turn off loading
        setCreatingBooking(false);

        // Set selected property and rooms
        const currentSelectedProperty = {
            ...selectedProperty,
            bookingData: bookingData,
            bookingId: result?.data?.bookingId || "0",
            bookingReservationCode: result?.data?.bookingReservationCode || "0",
            bookingConfirmationCode: result?.data?.bookingConfirmationCode || "0"
        }

        setSelectedProperty(currentSelectedProperty);

        // Pass 
        navigate("/order/hotel/booking/confirm");

        // showSuccess("Reserva criada!", "Você será redirecionado em breve.");

       /* setTimeout(() => {
            navigate("/order/hotel/booking/confirm");
        }, 3000);*/

    } else {

        // Turn off loading
        setCreatingBooking(false);

        if (result.error.includes('[TIMEOUT]')) {
            // Erro específico de timeout
            setAlertTitle("Tempo excedido");
            setAlertBody("A solicitação demorou demais para responder. Por favor, tente novamente ou verifique sua conexão.");
        } else {
            // Outros erros
            setAlertTitle("Erro");
            setAlertBody(result.error || "Erro ao criar a reserva.");
        }

        setAlert(true);
    }


};

// HELPER Generate voucher info for PDF
const generateVoucherInfo = () => {
    
  const hotel = selectedProperty.property;
  const room = selectedProperty.room[0];
  const enriched = room.enrichedData || {};
  const contact = enriched.contact || {};

  const data = {
    hotel_name: hotel.hotel_name +" - "+ selectedProperty.property.country +", "+selectedProperty.property.city,
    booking_period: `${moment(selectedProperty.dateRange[0]).format("DD/MM/YYYY")} a ${moment(selectedProperty.dateRange[1]).format("DD/MM/YYYY")}`,
    booking_number: 'N/D',
    hotel_address: hotel.hotel_address + ", " + selectedProperty.property.city +", "+selectedProperty.property.country,
    hotel_contact: {
      tel: hotel.phone ? hotel.phone : (contact.phone || ''),
      email: hotel.email ? hotel.email : (contact.email || ''),
      site: hotel.website ? hotel.website : (contact.website || '')
    },
    hotel_checkin: hotel?.checkin || "15:00 (confirmar com o hotel)",
    hotel_checkout: hotel?.checkout || "12:00 (confirmar com o hotel)",
    hotel_min_age_checkout: hotel?.min_age_checkout || "18",
    cancellation_deadline: roomCancelPolicy || '',
    cancellation_policy: room['cancellation-policy'] || '',
    total_amount: totalAmount
    ? `${formatNumberCurrency(totalAmount, exchangeRateInitials)}${
        nonUsdFees.length > 0 
          ? nonUsdFees.map(fee => ` + ${formatNumberCurrency(fee.total, fee.currency)}`).join('')
          : ''
      }`
    : '',

    total_booking: totalAmountPaidNow 
    ? `${formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)}` 
    : '',

    total_local: collectedFeeDetails && collectedFeeDetails.length > 0
    ? collectedFeeDetails.map(fee => `${formatNumberCurrency(fee.total, fee.currency)}`).join(' + ')
    : "0",
    additional_fees: (localCollectedFeeItems && localCollectedFeeItems.length > 0)
      ? localCollectedFeeItems.map(item => ({
          name: item.name,
          value: `${formatNumberCurrency(item.total, item.currency || currencyCollectedFeeAmount)}`
        }))
      : [],
    room: {
      title: room.room.title,
      room_name: room.extraDetails?.name?.en || '',
      room_responsible_name: responsibleName || '',
      room_hosts_label: selectedProperty.hostsLabel,
      room_extra: roomExtraInfo || 'Nenhum extra incluído',
      room_additional_info: roomAdditionalInfo || ''
    }
  };

    return data;

}

// Handle download quote PDF
const handleDownloadQuote = async () => {

  setLoadingQuote(true);


  // dOWNLOAD STARTED
    toast.current.show({ severity: 'info', summary: 'Gerando cotação', detail: 'O PDF está sendo gerado, por favor aguarde...', life: 4000 });


  const hotel = selectedProperty.property;
  const room = selectedProperty.room[0];
  const enriched = room.enrichedData || {};
  const contact = enriched.contact || {};

  const data = {
    hotel_name: hotel.hotel_name +" - "+ selectedProperty.property.country +", "+selectedProperty.property.city,
    booking_period: `${moment(selectedProperty.dateRange[0]).format("DD/MM/YYYY")} a ${moment(selectedProperty.dateRange[1]).format("DD/MM/YYYY")}`,
    booking_number: 'N/D',
    hotel_address: hotel.hotel_address + ", " + selectedProperty.property.city +", "+selectedProperty.property.country,
    hotel_contact: {
      tel: hotel.phone ? hotel.phone : (contact.phone || ''),
      email: hotel.email ? hotel.email : (contact.email || ''),
      site: hotel.website ? hotel.website : (contact.website || '')
    },
    hotel_checkin: hotel?.checkin || "15:00 (confirmar com o hotel)",
    hotel_checkout: hotel?.checkout || "12:00 (confirmar com o hotel)",
    hotel_min_age_checkout: hotel?.min_age_checkout || "18",
    cancellation_deadline: roomCancelPolicy || '',
    cancellation_policy: room['cancellation-policy'] || '',
    total_amount: totalAmount
    ? `${formatNumberCurrency(totalAmount, exchangeRateInitials)}${
        nonUsdFees.length > 0 
          ? nonUsdFees.map(fee => ` + ${formatNumberCurrency(fee.total, fee.currency)}`).join('')
          : ''
      }`
    : '',

    total_booking: totalAmountPaidNow 
    ? `${formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)}` 
    : '',

    total_local: collectedFeeDetails && collectedFeeDetails.length > 0
    ? collectedFeeDetails.map(fee => `${formatNumberCurrency(fee.total, fee.currency)}`).join(' + ')
    : "0",
    additional_fees: (localCollectedFeeItems && localCollectedFeeItems.length > 0)
      ? localCollectedFeeItems.map(item => ({
          name: item.name,
          value: `${formatNumberCurrency(item.total, item.currency || currencyCollectedFeeAmount)}`
        }))
      : [],
    room: {
      title: room.room.title,
      room_name: room.extraDetails?.name?.en || '',
      room_responsible_name: responsibleName || '',
      room_hosts_label: selectedProperty.hostsLabel,
      room_extra: roomExtraInfo || 'Nenhum extra incluído',
      room_additional_info: roomAdditionalInfo || ''
    }
  };

  const result = await downloadQuotePdf(data);

  setTimeout(() => {
    
    
    setLoadingQuote(false)

    if (result.success) {
        showSuccess("Download iniciado!", "O arquivo será baixado em instantes.");
    } else {
        toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Falha ao gerar PDF.', life: 4000 });
    }

  }, 2000);


};

const handleSendEmailQuote = async () => {

    setLoadingSendEmail(true);

// dOWNLOAD STARTED
    toast.current.show({ severity: 'info', summary: 'Enviando cotação', detail: 'O PDF está sendo enviado, por favor aguarde...', life: 4000 });    


    setTimeout(() => {
        setLoadingSendEmail(false);
        // Show success message
        showSuccess("Cotação enviada!", "Verifique com o destinatário se o e-mail foi recebido com sucesso.");
    }, 2000);
};

  return (
	<>
    
    {(creatingBooking) &&
        <>
        <div className="wrapper" style={{backgroundColor:"#00000066",zIndex:"999999",position:"fixed",left:0,top:0,display:"flex",justifyContent:"center",alignItems:"center",width:"100%",height:"100vh"}}>

                <div style={{backgroundColor:"#FFFFFF",display:"flex",justifyContent:"center",alignItems:"center",width:"50%",height:"45vh",borderRadius:"60px",padding:"30px"}}>

                    <div style={{flex:1,display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",width:"30vw"}}>
                        <ProgressSpinner />
                        <div className="formTitle" style={{marginBottom:"15px",marginTop:"15px"}}>Efetivando a sua reserva...Aguarde! </div>
                        <div className="formSubTitle">Isso levará um breve momento...Aguarde até a conclusão!</div>		
                        <div className="formSubTitle" style={{fontWeight:"bold",display:"flex",alignItems:"center",gap:"0.5rem"}}> <i className="pi pi-exclamation-triangle" style={{fontSize:"2rem",color:"orange"}}></i> Não recarregue ou saia dessa página</div>		                            
                        <div className="formSubTitle">DREAM4: hotéis 4 estrelas que você pode sonhar...</div>		

                    </div>

                </div>

        </div>
        </>
    }		
	
	<div id="navigationSection" style={{width:"100%",margin:"0",paddingTop:"0px",paddingBottom:"0px",position:"relative",borderRadius:0}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >

			<div style={{minHeight:"600px",height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 		
				<div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start"}}>
							
					<div style={{flex:1,minHeight:"594px",marginLeft:"auto",marginRight:"auto"}}>
						
					<div className="searchWrapper" style={{padding: "3rem",paddingTop:"1.8rem",display: "flex",flexDirection: "column",justifyContent: "center",alignItems: "flex-start",gap: "0.8rem",width: "100%"}}>

                        <div className="backAndsearchFields w100" style={{marginBottom:"1rem"}}>

                                <div className="searchWrapperInput" style={{flex:"1",width:"100%",marginTop:"20px"}}>

                                    <div container style={{width:"100%",maxWidth:"1440px",display:"flex",flexDirection:"row",justifyContent:"end",alignItems:"center",gap:"10px"}}>

                                        <div style={{flex:"1",textAlign:"left"}}>
                                            <Button icon="pi pi-arrow-left" label="Voltar para propriedade" text className="pT10 mR10 backButton" onClick={()=>{navigate(`/order/hotel/view/${selectedProperty?.property?.property_id || null}`)}} style={{color:"#814DE5"}} /> 
                                        </div>                                      
                                        
                                    </div>
                                    
                                </div>												  
                              
                        </div>
                     
						<div id="titleBox" className="titleBox selectBoxTitleOld animateOld flex-row justify-center align-items-center w100" style={{marginBottom:"0px",color: "#1D2939",fontSize: "2rem",fontStyle: "normal",fontWeight: 700,lineHeight: "2.12938rem",fontFamily:"Poppins",flex:"1",gap:"10px",maxWidth:"1440px"}} >


                            {/* LOADING  */}
                            {(contentLoading) &&
                                <>
                                    <div style={{backgroundColor:"transparent", width:"100%",marginTop:"5px",marginBottom:"5px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
                                    
                                        <div style={{flex:1}}>
                                            <Skeleton width="70%" height="5vh" ></Skeleton>
                                        </div>
                                                                                            
                                    </div>
                                                                     
                                </>				
                            }   

                            {/* LOADING  */}
                            {(!contentLoading) &&
                            <>
                                <div style={{textAlign:"left",flex:1,marginBottom:"2.5rem"}}>

                                    <div className="resultsCard_details__left flex-column justify-center align-items-start" style={{gap:"1.5rem",flex:1}}>

                                        <div className="resultsCard_details__name" style={{color: "#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",
                                        fontStyle: "normal",fontWeight: 700,lineHeight: "normal",textAlign:"left"}}>Confirmação de dados da reserva</div>

                                        <div className="resultsCard_details__name" style={{color:"#475467",fontFamily:"Poppins",fontSize:"1.125rem",fontStyle:"normal",fontWeight:400,lineHeight:"160.5%",letterSpacing:"0.1125rem"}}>Confirme os dados da reserva abaixo. Se desejar, adicione instruções especiais no quarto. <br /> Defina o responsável pela reserva e dados dos hóspedes.</div>

                                    </div>

                                </div>
                            </>
                            }

						</div>
        
						<div className="navigationContentWrapper flex-row justify-center align-items-start" style={{maxWidth:"1440px",marginTop:"0",width:"100%",flex:1,gap:"1rem"}}>

									<div className="resultsWrapper flex-column justify-center align-items-center" style={{gap:"1rem",flex:1}}>
								
                                        {/* HOTEL DETAILS - START */}
                                        <div className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div className="w100 flex-row justify-center align-items-stretch" style={{gap:"40px",height:"50vh"}}>
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="20rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>                              
                                                        </div>                                              
                                                    </div>
                                                </>				
                                            }                                            

                                            {/* LOADING  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

                                                    <div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

                                                        <div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
                                            
                                                            <div className="bookingDetails_title">Resumo das seleções</div>

                                                            <div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"745px"}}>

                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Destino selecionado</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.property?.country ? (selectedProperty.property.country +","+selectedProperty.property.city) : "carregando..." }</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Hotel selecionado</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.property?.hotel_name || "carregando..."}</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Data de hospedagem</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.dateRange ? (moment(selectedProperty?.dateRange[0]).format("DD/MM/YYYY") + " a " +moment(selectedProperty?.dateRange[1]).format("DD/MM/YYYY")) : "carregando..."}</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Número de diárias</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty.dateRangeDays || "carregando..."}</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Número de hospedes</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.hostsLabel || "carregando..."}</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem",marginTop:"2rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Quarto 1</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.room?.[0]?.room?.title || "carregando..."}</div>
                                                                </div>  


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Hóspedes</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.hostsLabel || "carregando..."}</div>
                                                                </div>


                                                                {selectedProperty.room.map((item, index) =>{

                                                                        const valueAdds = item.valueAdds ? item.valueAdds?.["value-add"] : item?.["value-adds"]?.["value-add"]; // Safe access
                                                                        
                                                                        const totalPricewithMarkup = item?.updatedPriceWithMarkup || item.totalWithMarkup;
                                                                        
                                                                        const rawFee = item?.localCollectedFee?.fees || item?.localCollectedFee;

                                                                        const localCollectedFee = Array.isArray(rawFee)
                                                                        ? rawFee.filter(f => f?.relation === 'display' || f?.relation === undefined)
                                                                        : rawFee;


                                                                        // Função para verificar se um código específico está presente
                                                                        const hasCode = (code) => {
                                                                            if (!valueAdds) return false;

                                                                            // Verifica se é um array
                                                                            if (Array.isArray(valueAdds)) {
                                                                            return valueAdds.some((valueAdd) => valueAdd.code === code);
                                                                            }

                                                                            // Caso seja um objeto único
                                                                            return valueAdds.code === code;
                                                                        };

                                                                    
                                                                        // Set Deadline if origin is hyperguest
                                                                        if (selectedProperty.origin == "hyperguest") {
                                                                            const daysBefore = item.cancellationPolicies?.[0]?.daysBefore || 0;
                                                                            const cancellationDeadline = moment(dateRange[0]).businessSubtract(daysBefore, 'days').format('YYYY-MM-DD')
                                                                            item['cancellation-deadline'] = cancellationDeadline;
                                                                        }
                                                                                                                    
                                                                        // const hasFreeCancellation = hasCode("free_cancellation");
                                                                        const hasFreeCancellation = item['cancellation-deadline'] ? item['cancellation-deadline'] : false;
                                                                        const hasFreeBreakfast = hasCode("free_breakfast");


                                                                        return(
                                                                        <>
                                                                            <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                                <div className="bookingDetails_wrapper_item_label">Extras</div>
                                                                                <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                                <div className="bookingDetails_wrapper_item_value">                                      {hasFreeBreakfast && <>Café da manhã incluído</> }
                                                                                     {!hasFreeBreakfast && <>Nenhuma opção extra</>}  
                                                                                  </div>
                                                                            </div>  


                                                                            <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                                <div className="bookingDetails_wrapper_item_label">Cancelamento</div>
                                                                                <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                                <div className="bookingDetails_wrapper_item_value">
                                                                                    
                                                                                    {hasFreeCancellation && <>Cancelamento Gratuito <label style={{color:"#878787"}}>até {moment(item['cancellation-deadline']).businessSubtract(2, 'days').format('DD/MM/YYYY')}</label></>}
                                                                                    {!hasFreeCancellation && <>Cancelamento não reembolsável</>}
                                                                                    
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        );

                                                                })}

                                                                {localCollectedFeeItems?.length > 0 && (
                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label tAlignL">Tarifas cobradas no local</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">

                                                                        {localCollectedFeeItems.map((item, index) => (
                                                                            <div key={index} className="bookingDetails_wrapper_item_value_item tAlignR">
                                                                                {item.name}: {formatNumberCurrency(item.total, item.currency || currencyCollectedFeeAmount)}
                                                                            </div>
                                                                        ))}
    
                                                                    </div>
                                                                </div>)
                                                                }

                                                            </div>

                                                            <div className="bookingTotals" style={{marginTop:"4rem",width:"80%",maxWidth:"745px"}}>



                                                                    {/* TOTALS */}
                                                                    {/*<div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%",gap:"0.5rem"}}>

                                                                        <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{padding:"0.5rem",gap:"0.5rem",width:"100%"}}>

                                                                            <div className="flex-column justify-center align-items-right w100">

                                                                                {currencyCollectedFeeAmount == "USD" &&
                                                                                <>                                                                   
                                                                                    <div className="bookingTotals_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                                        <div className="bookingTotals_wrapper_item_label">Total da hospedagem</div>
                                                                                        <div className="bookingTotals_wrapper_item_line flex-1"></div>
                                                                                        <div className="bookingTotals_wrapper_item_value"> {formatNumberCurrency(totalAmount,exchangeRateInitials)}</div>
                                                                                    </div>
                                                                                </>
                                                                                }	

                                                                                {(currencyCollectedFeeAmount != "USD" && totalCollectedFeeAmount > 0) &&
                                                                                <>
                                                                                    <div className="bookingTotals_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                                        <div className="bookingTotals_wrapper_item_label">Total da hospedagem</div>
                                                                                        <div className="bookingTotals_wrapper_item_line flex-1"></div>
                                                                                        <div className="bookingTotals_wrapper_item_value"> {formatNumberCurrency(totalAmountPaidNow,exchangeRateInitials)} + <span style={{fontSize: "0.9375rem"}}>{formatNumberCurrency(totalCollectedFeeAmount,currencyCollectedFeeAmount)}</span></div>
                                                                                    </div>   
                                                                                </>
                                                                                }


                                                                                <div className="resultsCard_details__prices___dailyPrice w100" style={{color: "#878787",fontFamily: "Titillium Web",fontSize: "0.85rem",fontStyle: "normal",fontWeight: 400,lineHeight: "1.625rem",letterSpacing: "0.02875rem",textAlign:"right"}}>inclui impostos e taxas</div>

                                                                                <div className="resultsCard_details__prices___dailyPrice w100" style={{color:" #878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "2.12938rem",textAlign:"right",marginTop:"1rem"}}><span style={{fontSize: "0.85rem"}}>Pagar na reserva </span> {formatNumberCurrency(totalAmountPaidNow,exchangeRateInitials)}</div>       


                                                                                {totalCollectedFeeAmount &&
                                                                                    <>
                                                                                    <div className="resultsCard_details__prices___dailyPrice w100" style={{color:" #878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "2.12938rem",textAlign:"right",marginTop:"1rem"}}><span style={{fontSize: "0.85rem"}}>Pagar na propriedade </span> {formatNumberCurrency(totalCollectedFeeAmount,currencyCollectedFeeAmount)}

                                                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{color: "rgb(183 183 183)",lineHeight:"1rem",fontFamily: "Titillium Web",fontSize: "0.75rem",fontStyle: "normal",fontWeight: 600,letterSpacing: "0.02875rem",textAlign:"right"}}>Os impostos e/ou taxas a serem pagos na propriedade serão pagos sempre na moeda local.</div>

                                                                                    </div>
                                                                                    </>
                                                                                }                                                         
                                                         
                                                                                
                                                                            </div>   

                                                                        </div>
                                                                    
                                                                    </div>*/}

                                                                    {/* TOTALS */}
                                                                    <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%", gap:"0.5rem"}}>

                                                                        <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{padding:"0.5rem", gap:"0.5rem", width:"100%"}}>

                                                                            <div className="flex-column justify-center align-items-right w100">

                                                                                {/* Total da hospedagem */}
                                                                                <div className="bookingTotals_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                                    <div className="bookingTotals_wrapper_item_label">Total da hospedagem</div>
                                                                                    <div className="bookingTotals_wrapper_item_line flex-1"></div>
                                                                                    <div className="bookingTotals_wrapper_item_value">
                                                                                        {formatNumberCurrency(totalAmount, exchangeRateInitials)}
                                                                                        {nonUsdFees.length > 0 && nonUsdFees.map((fee, idx) => (
                                                                                            <span key={idx}> + {formatNumberCurrency(fee.total, fee.currency)}</span>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>

                                                                                {/* Inclui impostos e taxas */}
                                                                                <div className="resultsCard_details__prices___dailyPrice w100" style={{color: "#878787", fontFamily: "Titillium Web", fontSize: "0.85rem", fontWeight: 400, lineHeight: "1.625rem", letterSpacing: "0.02875rem", textAlign:"right"}}>
                                                                                    inclui impostos e taxas
                                                                                </div>

                                                                                {/* Pagar na reserva */}
                                                                                <div className="resultsCard_details__prices___dailyPrice w100" style={{color:"#878787", fontFamily: "Poppins", fontSize: "1rem", fontWeight: 400, lineHeight: "2.12938rem", textAlign:"right", marginTop:"1rem"}}>
                                                                                    <span style={{fontSize:"0.85rem"}}>Pagar na reserva </span>
                                                                                    {formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)}
                                                                                </div>

                                                                                {/* Pagar na propriedade */}
                                                                                {collectedFeeDetails.length > 0 && (
                                                                                    <div className="resultsCard_details__prices___dailyPrice w100" style={{color:"#878787", fontFamily: "Poppins", fontSize: "1rem", fontWeight: 400, lineHeight: "2.12938rem", textAlign:"right", marginTop:"1rem"}}>
                                                                                        <span style={{fontSize:"0.85rem"}}>Pagar na propriedade </span>
                                                                                        {collectedFeeDetails.map((fee, idx) => (
                                                                                            <span key={idx}>{idx > 0 ? " + " : ""}{formatNumberCurrency(fee.total, fee.currency)}</span>
                                                                                        ))}
                                                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{color: "rgb(183 183 183)", lineHeight:"1rem", fontFamily: "Titillium Web", fontSize: "0.75rem", fontWeight:600, textAlign:"right"}}>
                                                                                            Os impostos e/ou taxas a serem pagos na propriedade serão pagos sempre na moeda local.
                                                                                        </div>
                                                                                    </div>
                                                                                )}

                                                                            </div>   

                                                                        </div>

                                                                    </div>
                                                                    {/* TOTALS END */}


                                                            </div>

                                                        </div>

                                                    </div> 

                                                </div>

                                            </>
                                            }

                                        </div>
                                        {/* HOTEL DETAILS - END */}  

                                        {/* HOTEL ADDITIONAL INFO - START */}
                                        <div className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div className="w100 flex-row justify-center align-items-stretch" style={{gap:"40px",height:"50vh"}}>
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="20rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>                              
                                                        </div>                                              
                                                    </div>
                                                </>				
                                            }                                            

                                            {/* LOADING  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

                                                    <div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"start",alignItems:"center",position:"relative"}}>

                                                        <div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem",maxWidth:"745px"}}>
                                            
                                                            <div className="bookingDetails_title">Quarto: {selectedProperty.room?.[0]?.room?.title || "carregando..."}</div>

                                                            <div className="bookingDetails_subtitle">Possui alguma solicitação especial?</div>

                                                            <div className="bookingDetails_description">Inclua os detalhes da sua solicitação especial e vamos encaminhá-los para a propriedade. Importante: a sua solicitação não está garantida e, se você não receber nenhuma resposta, entre em contato diretamente com a propriedade para confirmar.</div>

                                                            <div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem"}}>

                                                                <div className="card flex justify-content-center w100">
                                                                    <span className="p-float-label w100">
                                                                        <InputTextarea
                                                                            id="additionalInfo"
                                                                            className="w100"
                                                                            value={roomAdditionalInfo}
                                                                            onChange={handleAdditionalInfoChange}
                                                                            rows={5}
                                                                            placeholder="Descreva suas solicitações especiais. Exemplo: Cama de casal, secador no banheiro, quarto para não fumante e etc.."
                                                                        />
                                                                    </span>
                                                                    <div className="flex-row justify-content-between w100" style={{ fontSize: '0.85rem', marginTop: '4px',justifyContent:"space-between"}}>
                                                                        <small>Máximo de {maxChars} caracteres.</small>
                                                                        <small style={{ color: isLimitReached ? 'red' : 'inherit' }}>
                                                                            {roomAdditionalInfo.length}/{maxChars}
                                                                        </small>
                                                                    </div>
                                                                </div>                                                              
                                                                
                                                            </div>

                                                        </div>

                                                    </div> 

                                                </div>

                                            </>
                                            }

                                        </div>

                                        {/* HOTEL POLICY- START */}
                                        <div className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div className="w100 flex-row justify-center align-items-stretch" style={{gap:"40px",height:"50vh"}}>
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="20rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>                              
                                                        </div>                                              
                                                    </div>
                                                </>				
                                            }                                            

                                            {/* LOADING  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

                                                    <div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"start",alignItems:"center",position:"relative"}}>

                                                        <div  className="customTab flex-column align-items-start justify-center w100">

                                                            <div className="bookingDetails_title">Termos e condições</div>                                                            

                                                            <div className="flex-row justify-start align-items-stretch w100" style={{padding:"1rem",backgroundColor:"transparent",gap:"2rem",flex:1,flexWrap:"wrap"}}>

                                                            <div className="flex-column justify-center align-items-stretch" style={{gap:"0.5rem",width:"100%"}}>

                                                                <div style={{color:"#1D2939",fontFamily:"Poppins",fontSize:"1rem",fontStyle:"normal",fontWeight:"600",lineHeight:"normal",textAlign:"left"}}>Política de cancelamento</div> 
                                                                <div style={{color: "#878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "normal",textAlign:"left",marginBottom:"1rem"}}>
                                                                    Ao efetuar esta reserva, concordo em cumprir os termos e condições e aceito a política de cancelamento. Cada quarto nesta reserva está sujeito à seguinte política de cancelamento: Cancelamentos realizados antes da data máxima de cancelamento informada acima são totalmente reembolsáveis. Reservas canceladas após essa data não são reembolsáveis. Não há reembolso para não comparecimento, saídas antecipadas ou cancelamentos após a data final especificada acima.

                                                                    <b>Para cancelamentos realizados com pagamento via cartão de crédito, será aplicada uma taxa administrativa de 3,5%.</b>
                                                                </div>

                                                                <div style={{color:"#1D2939",fontFamily:"Poppins",fontSize:"1rem",fontStyle:"normal",fontWeight:"600",lineHeight:"normal",textAlign:"left"}}>Antecedência e disponibilidade através da plataforma</div> 
                                                                <div style={{color: "#878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "normal",textAlign:"left",marginBottom:"1rem"}}>
                                                                    Reservas só podem ser feitas com antecedência mínima de 3 dias corridos da data do serviço. Recomendamos avisar nossa central de atendimento, assim que uma reserva for realizada, para que possamos acompanhar o processo.
                                                                    Pedidos com menos de três dias corridos de sua utilização e condições excepcionais de pagamento. Reservas solicitadas com prazo inferior a três dias antes do check-in e/ou pagamentos realizados com cartão de terceiros não poderão ser efetuados pela plataforma. Nestes casos, é necessário entrar em contato com a central de atendimento.
                                                                </div>

                                                                <div style={{color:"#1D2939",fontFamily:"Poppins",fontSize:"1rem",fontStyle:"normal",fontWeight:"600",lineHeight:"normal",textAlign:"left"}}>Pagamentos através da plataforma</div> 
                                                                <div style={{color: "#878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "normal",textAlign:"left",marginBottom:"1rem"}}>
                                                                    Os pagamentos através da plataforma deverão ser feitos exclusivamente através do cartão de crédito do titular do serviço (passageiro líder), respeitando a grafia de seu nome conforme inserido na reserva e com a data de vencimento do cartão no formato DD/AAAA para que o pagamento seja aprovado. Isso não se aplica para pagamento com PIX. 
                                                                </div> 

                                                                <div style={{color:"#1D2939",fontFamily:"Poppins",fontSize:"1rem",fontStyle:"normal",fontWeight:"600",lineHeight:"normal",textAlign:"left"}}>Preços</div> 
                                                                <div style={{color: "#878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "normal",textAlign:"left",marginBottom:"1rem"}}>
                                                                    O valor apresentado para pagamento da reserva está em USD. No momento do pagamento, será realizada a conversão para BRL, utilizando a cotação vigente na data. Caso existam valores adicionais a serem pagos diretamente na propriedade, estes deverão ser quitados sempre na moeda local.
                                                                </div> 

                                                                <div style={{color:"#1D2939",fontFamily:"Poppins",fontSize:"1rem",fontStyle:"normal",fontWeight:"600",lineHeight:"normal",textAlign:"left"}}>Requisitos de Check-In</div> 
                                                                <div style={{color: "#878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "normal",textAlign:"left",marginBottom:"1rem"}}>
                                                                    Um documento de identificação válido e um cartão de crédito ou débito em nome do titular da reserva são necessários no check-in. A idade mínima para check-in será especificada no momento da reserva.
                                                                    Os cartões de crédito ou débito podem ser pré-autorizados para cobranças incidentais, e o valor exigido pode variar de acordo com o hotel.
                                                                </div> 

                                                                <div style={{color:"#1D2939",fontFamily:"Poppins",fontSize:"1rem",fontStyle:"normal",fontWeight:"600",lineHeight:"normal",textAlign:"left"}}>Alterações na reserva</div> 
                                                                <div style={{color: "#878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "normal",textAlign:"left",marginBottom:"1rem"}}>
                                                                    Para realizar qualquer alteração na reserva, será necessário cancelar a reserva atual e efetuar uma nova. Em caso de cancelamentos pagos via cartão de crédito, será cobrada uma taxa administrativa de 3,5%.
                                                                </div> 

                                                                <div style={{color:"#1D2939",fontFamily:"Poppins",fontSize:"1rem",fontStyle:"normal",fontWeight:"600",lineHeight:"normal",textAlign:"left"}}>Necessidades Especiais e Solicitações</div> 
                                                                <div style={{color: "#878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "normal",textAlign:"left",marginBottom:"1rem"}}>
                                                                    Caso possua necessidades especiais (ex.: acomodações para deficiência ou preferências de quarto), adicione nas solicitações especiais acima e entre em contato diretamente com nossa equipe de suporte após a reserva para tentar garantir que seus requisitos possam ser atendidos. Nossa plataforma não garante essas solicitações.
                                                                </div> 

                                                                <div style={{color:"#1D2939",fontFamily:"Poppins",fontSize:"1rem",fontStyle:"normal",fontWeight:"600",lineHeight:"normal",textAlign:"left"}}>Impostos e Taxas</div> 
                                                                <div style={{color: "#878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "normal",textAlign:"left",marginBottom:"1rem"}}>
                                                                    As informações sobre impostos e taxas incluem encargos aplicáveis ao hotel, como impostos de ocupação, impostos sobre vendas e outras cobranças exigidas por lei. Adicionalmente, alguns hotéis podem cobrar taxas obrigatórias, como, por exemplo, taxas de turismo e resort, que devem ser quitadas diretamente no momento do check-out.
                                                                </div> 

                                                                <div style={{color:"#1D2939",fontFamily:"Poppins",fontSize:"1rem",fontStyle:"normal",fontWeight:"600",lineHeight:"normal",textAlign:"left"}}>Isenção de Responsabilidade</div> 
                                                                <div style={{color: "#878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "normal",textAlign:"left",marginBottom:"1rem"}}>
                                                                    Nossa plataforma atua como facilitadora de reservas e não se responsabiliza por eventuais discrepâncias nos serviços ou comodidades oferecidos pelo hotel, que ficam a critério da administração do mesmo. No entanto, nossa equipe está sempre à disposição e fará o possível para intermediar e atender às solicitações dos clientes, buscando alcançar o resultado desejado.
                                                                    Todas as reservas estão sujeitas aos termos e condições do respectivo hotel.
                                                                    Ao concluir uma reserva em nosso site, você reconhece e aceita estes termos e condições.
                                                                    Para dúvidas ou assistência adicional, entre em contato com nossa equipe de suporte.
                                                                </div> 
                                                            </div>
                                                                                                                                            
                                                            </div>
                                                        </div>

                                                    </div> 

                                                </div>

                                            </>
                                            }

                                        </div>



                                        {/* HOTEL DETAILS - END */}                                                                 

									</div>
                                    
                                    {/* RIGHT COLUMN WITH CART DETAILS*/}
									<div className="filterWrapper flex-column justify-center align-items-start" style={{width:"25rem",height:"auto",gap:"1.5rem"/*,position:"sticky",top:"90px"*/}}>

                                        {/* Responsavel pela reserva e hospedes */}
										<div className="filterOptions flex-column justify-center align-items-center" style={{width:"100%",height:"auto",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem",gap:"1rem"}}>

                                            {/* Responsavel pela reserva e hospedes BLOCK */}
											<div className="filterOptions_title w100" style={{color:"#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",fontStyle: "normal",fontWeight: 500,lineHeight: "2.12938rem",textAlign:"left",marginTop:"0.5rem"}}>Responsável pelo pagamento</div>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div style={{backgroundColor:"transparent", width:"100%",marginTop:"5px",marginBottom:"5px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
                                                    
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />      
                                                            <Skeleton width="100%" height="5vh" ></Skeleton>
                                                            
                                                        </div>
                                                                                                            
                                                    </div>
                                                                                    
                                                </>				
                                            }   	

                                            {/* LOADED  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="filterOptions_priceFilter flex-column justify-center align-items-center w100" style={{gap:"0.5rem"}}>

                                                    <Grid container spacing={4} style={{width:"100%"}}>

                                                       <Grid item xs={12} sm={12} >
                                                        <div className="flex-row justify-content-start align-items-center gap-1" style={{gap:"1rem"}}>
                                                                <InputSwitch
                                                                id="responsibleIsGuest"
                                                                checked={responsibleIsGuest}
                                                                onChange={(e) => setResponsibleIsGuest(e.value)}
                                                                />
                                                                <label htmlFor="responsibleIsGuest">O responsável é um dos hóspedes</label>
                                                            </div>
                                                        </Grid>     

                                                        <Grid item xs={12} sm={12} >
                                                        <div className="flex-row justify-content-start align-items-center gap-1" style={{gap:"1rem"}}>
                                                                <InputSwitch
                                                                id="responsibleDocumentType"
                                                                checked={responsibleDocumentType}
                                                                onChange={(e) => handleResponsibleDocumentType(e.value)}
                                                                />
                                                                <label htmlFor="responsibleDocumentType">O responsável é estrangeiro</label>
                                                            </div>
                                                        </Grid>                                                                                                           

                                                        <Grid item xs={12} sm={12} >
                                                            <div className="flex-column justify-content-start align-items-center gap-1" style={{gap:"0.5rem"}}>
                                                                <div className="w100 p-inputgroup">
                                                                    <InputText
                                                                    id="responsibleDocument"
                                                                    className="w100 tAlignL" 
                                                                    value={responsibleDocument}
                                                                    onChange={
                                                                        (responsibleDocumentType) 
                                                                        ? (e) => setResponsibleDocument(e.target.value) 
                                                                        : (e) => setResponsibleDocument(maskCPF(e.target.value.replace(/\D/g, '')))
                                                                    }                                                                    
                                                                    placeholder={responsibleDocumentType ? "Informe o número do passaporte" : "Informe o CPF"}
                                                                    style={{width:"100%"}}
                                                                    />                                           
                                                                    {!responsibleDocumentType && (
                                                                        <Button
                                                                            label="Buscar"
                                                                            loading={responsibleFetching}
                                                                            onClick={() => fetchHostData("responsibleDocument")}
                                                                            style={{fontSize:"0.85rem",paddingLeft:"1rem"}}
                                                                        />
                                                                    )}                                                                    
                                                                </div>
                                                                {!responsibleDocumentType && (
                                                                <small style={{color:"#878787",fontSize:"0.75rem",textAlign:"left"}}>
                                                                    Informe o CPF e selecione buscar para preencher o nome e data de nascimento automaticamente.
                                                                </small>)
                                                                }                                                                
                                                            </div>                                                           
                                                        </Grid>
                                                        

                                                        <Grid item xs={12} sm={12} >
                                                            <div className="flex-column justify-content-start align-items-center gap-1" style={{gap:"0.5rem"}}>
                                                                <span className="w100 p-float-label">
                                                                    <InputText
                                                                    id="responsibleName"
                                                                    className="w100 tAlignL" 
                                                                    value={responsibleName}
                                                                    disabled={!responsibleManualEdit}
                                                                    onChange={(e) => setResponsibleName(e.target.value)}
                                                                    placeholder={responsibleDocumentType ? "Informe o nome completo" : "Automático / Preencha o CPF"}
                                                                    style={{width:"100%"}}
                                                                    />
                                                                    <label className="w100 tAlignL"  htmlFor="name">Nome completo</label>
                                                                </span>
                                                            </div>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} >
                                                            <div className="w100" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                                <span className="w100 p-float-label">
                                                                    <InputText
                                                                        id="responsibleBirthDate"
                                                                        className="w100 tAlignL"
                                                                        value={responsibleBirthDate}
                                                                        disabled={!responsibleManualEdit}
                                                                        onChange={(e) => {
                                                                        const formatted = aplicarMascaraDataNascimento(e.target.value);
                                                                        setResponsibleBirthDate(formatted);
                                                                        }}                                                                        
                                                                        placeholder={responsibleDocumentType ? "Informe a data de nascimento" : "Automático / Preencha o CPF"}
                                                                        style={{ width: "100%" }}
                                                                    />
                                                                    <label className="w100 tAlignL" htmlFor="responsibleBirthDate">Data de nascimento</label>
                                                                </span>

                                                                <span style={{ position: "absolute", top: '0px', right: '15px', color: '#999', transform: "translateY(50%)" }}>
                                                                    {calcularIdade(responsibleBirthDate) ? `${calcularIdade(responsibleBirthDate)} anos` : ''}
                                                                </span>
                                                            </div>
                                                        </Grid>
                                                        
                                                        <Grid item xs={12} sm={12} >
                                                            <div className="flex-column justify-content-start align-items-center gap-1" style={{gap:"0.5rem"}}>
                                                                <span className="w100 p-float-label">
                                                                    <InputText
                                                                    id="responsibleEmail"
                                                                    className="w100 tAlignL" 
                                                                    value={responsibleEmail}
                                                                    onChange={(e) => setResponsibleEmail(e.target.value)}
                                                                    placeholder="Informe o Email do responsável"
                                                                    style={{width:"100%"}}
                                                                    />
                                                                    <label className="w100 tAlignL"  htmlFor="name">Email</label>
                                                                </span>
                                                            </div>
                                                       
                                                        </Grid> 

                                                        <Grid item xs={12} sm={12} >
                                                            <div className="flex-column justify-content-start align-items-center gap-1" style={{gap:"0.5rem"}}>
                                                                <span className="w100 p-float-label">
                                                                    <InputText
                                                                    id="responsiblePhone"
                                                                    className="w100 tAlignL" 
                                                                    value={responsiblePhone}
                                                                    onChange={(e) => setResponsiblePhone(maskPhone(e.target.value))}
                                                                    placeholder="Informe o telefone celular do responsável"
                                                                    style={{width:"100%"}}
                                                                    />
                                                                    <label className="w100 tAlignL"  htmlFor="name">Telefone celular</label>
                                                                </span>
                                                            </div>
                                                       
                                                        </Grid>                                                         
                                                                                                                              

                                                    </Grid>

                                                    

                                                </div>

                                                <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"1rem",padding:"0.5rem"}}>
                                                    <img src={iconResponsibleWarning} alt="Aviso de Responsável" style={{width:"2.5rem",height:"auto"}} />
                                                    <div className="responsibleWarning">O responsável pelo pagamento deve ser um dos hóspedes abaixo. Caso não seja, para realizar o pagamento após a reserva, você deverá falar com a Central de atendimento.</div>
                                                </div>

                                            </>
                                            }

                                            {/* Dados dos hospedes BLOCK */}
											<div className="filterOptions_title w100" style={{color:"#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",fontStyle: "normal",fontWeight: 500,lineHeight: "2.12938rem",textAlign:"left",marginTop:"1.5rem"}}>Dados dos hóspedes</div>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div style={{backgroundColor:"transparent", width:"100%",marginTop:"5px",marginBottom:"5px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
                                                    
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />      
                                                            <Skeleton width="100%" height="5vh" ></Skeleton>
                                                            
                                                        </div>
                                                                                                            
                                                    </div>
                                                                                    
                                                </>				
                                            }   

                                            {/* LOADED  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="filterOptions_priceFilter flex-column justify-center align-items-center w100" style={{gap:"0.5rem"}}>

                                                    {/**Formularios por hospede */}
                                                    {hostsArray.map((host, i) => {
                                                        const isChild = host.type === 'child';
                                                        const label = isChild
                                                            ? `Criança (${host.age} anos)`
                                                            : 'Adulto';

                                                        const title = `Hóspede ${i + 1}: ${label}`;

                                                        return (
                                                            <Panel
                                                                key={`panel-${i}`}
                                                                className="hostsPanel w100"
                                                                header={title}
                                                                toggleable
                                                                collapsed={!(panelVisibility[i] ?? i === 0)}
                                                               
                                                            >
                                                                <Grid container spacing={3}>
                                                                    <Grid item xs={12}>
                                                                        <div className="flex-row justify-content-start align-items-center" style={{ gap: '1rem' }}>
                                                                            <InputSwitch
                                                                                checked={hostDocumentType[i] || false}
                                                                                onChange={(e) => handleHostDocumentTypeChange(i, e.value)}
                                                                            />
                                                                            <label>Marque se for estrangeiro</label>
                                                                        </div>
                                                                    </Grid>

                                                                    {isChild && (
                                                                        <Grid item xs={12}>
                                                                            <div className="flex-row justify-content-start align-items-center" style={{ gap: '1rem' }}>
                                                                                <InputSwitch
                                                                                    checked={hostNoCpf[i] || false}
                                                                                    onChange={(e) => handleHostNoCpfChange(i, e.value)}
                                                                                />
                                                                                <label>Marque se não tiver CPF</label>
                                                                            </div>
                                                                        </Grid>
                                                                    )}

                                                                    <Grid item xs={12}>
                                                                        <div className="p-inputgroup w100">
                                                                            <InputText
                                                                                className="w100 tAlignL"
                                                                                value={hostDocument[i] || ''}
                                                                                onChange={
                                                                                    (hostNoCpf[i] || hostDocumentType[i]) 
                                                                                    ? (e) => handleHostDocumentChange(i, e.target.value) 
                                                                                    : (e) => handleHostDocumentChange(i, maskCPF(e.target.value.replace(/\D/g, '')))
                                                                                }
                                                                                placeholder={
                                                                                    hostNoCpf[i]
                                                                                        ? 'Informe o número do RG (opcional)'
                                                                                        : hostDocumentType[i]
                                                                                            ? 'Informe o número do passaporte'
                                                                                            : 'Informe o CPF'
                                                                                }
                                                                                disabled={false}
                                                                            />
                                                                            {/* Só exibe o botão buscar se NÃO for estrangeiro e NÃO marcou “sem CPF” */}
                                                                            {!hostDocumentType[i] && !hostNoCpf[i] && (
                                                                                <Button
                                                                                    label="Buscar"
                                                                                    loading={hostFetching[i]}
                                                                                    onClick={() => fetchHostData(i)}
                                                                                    
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        {(!hostNoCpf[i] && !hostDocumentType[i]) && (
                                                                        <small style={{color:"#878787",fontSize:"0.75rem",textAlign:"left"}}>
                                                                            Informe o CPF e selecione buscar para preencher o nome e data de nascimento automaticamente.
                                                                        </small>)
                                                                        }                                                                          
                                                                    </Grid>

                                                                    <Grid item xs={12}>
                                                                        <div className="flex-column" style={{ gap: '0.5rem' }}>
                                                                            <span className="w100 p-float-label">
                                                                                <InputText
                                                                                    className="w100 tAlignL"
                                                                                    value={hostName[i] || ''}
                                                                                    onChange={(e) => handleHostNameChange(i, e.target.value)}
                                                                                    placeholder={
                                                                                        hostDocumentType[i] || hostNoCpf[i]
                                                                                            ? 'Informe o nome completo'
                                                                                            : 'Automático / Preencha o CPF'
                                                                                    }
                                                                                    disabled={!hostManualEdit[i]}
                                                                                />
                                                                                <label>Nome completo</label>
                                                                            </span>
                                                                        </div>
                                                                    </Grid>

                                                                    <Grid item xs={12}>
                                                                        <div className="w100" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                                            <span className="w100 p-float-label">
                                                                                <InputText
                                                                                    id={`hostBirthdate-${i}`}
                                                                                    value={hostBirthdate[i] || ''}
                                                                                    className="w100 tAlignL"
                                                                                    onChange={(e) => {
                                                                                        const formatted = aplicarMascaraDataNascimento(e.target.value);
                                                                                        setHostBirthdate((prev) => ({ ...prev, [i]: formatted }));
                                                                                    }}
                                                                                    placeholder="DD/MM/AAAA"
                                                                                    disabled={!hostManualEdit[i]}
                                                                                    
                                                                                />
                                                                                <label htmlFor={`hostBirthdate-${i}`}>Data de nascimento</label>
                                                                            </span>

                                                                            <span style={{ position:"absolute",top:'0px', right: '15px', color: '#999',transform:"translateY(50%)"}}>
                                                                                {calcularIdade(hostBirthdate[i]) ? `${calcularIdade(hostBirthdate[i])} anos` : ''}
                                                                            </span>
                                                                        </div>

                                                                        {/* Aviso de Responsável */}
                                                                        {i == 0 && (
                                                                        <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"1rem",padding:"0.5rem"}}>
                                                                            <img src={iconResponsibleWarning} alt="Aviso de Responsável" style={{width:"2rem",height:"auto"}} />
                                                                            <div className="responsibleWarning" style={{fontSize:"0.75rem"}}>O primeiro adulto será o responsável pela reserva. </div>
                                                                        </div>)
                                                                        }

                                                                    </Grid>
                                                                </Grid>
                                                            </Panel>
                                                        );
                                                    })}

                                                </div>
                                            </>
                                            }

										</div>

                                            
                                        {/* Resumo da reserva */}
										<div className="filterOptions flex-column justify-center align-items-center" style={{width:"100%",height:"auto",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem",gap:"2rem"}}>

											<div className="filterOptions_title w100" style={{color:"#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",fontStyle: "normal",fontWeight: 500,lineHeight: "2.12938rem",textAlign:"left",marginTop:"0.5rem"}}>Resumo da reserva</div>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div style={{backgroundColor:"transparent", width:"100%",marginTop:"5px",marginBottom:"5px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
                                                    
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />      
                                                            <Skeleton width="100%" height="5vh" ></Skeleton>
                                                            
                                                        </div>
                                                                                                            
                                                    </div>
                                                                                    
                                                </>				
                                            }   	

                                            {/* LOADED  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="filterOptions_priceFilter flex-column justify-center align-items-center w100" style={{gap:"0.5rem"}}>

                                                    <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%",gap:"0.5rem"}}>
                                                    
                                                        <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{gap:"1rem",width:"100%"}}>

                                                            <div className="flex-row justify-center align-items-center w100" style={{gap:"0.5rem",paddingBottom:"1rem",borderBottom:"1px solid #F8F8F8"}}>
                                                                <div style={{flex:1,textAlign:"left",color: "#475467",fontFamily: "Poppins",fontSize: "1.125rem",fontStyle: "normal",fontWeight: 400,lineHeight: "1.625rem",letterSpacing: "0.02875rem"}}>Período</div>
                                                                <div style={{flex:1.5,flexWrap:"nowrap",textAlign:"right",color: "#475467",fontFamily: "Poppins",fontSize: "0.875rem",fontStyle: "normal",fontWeight: 400,lineHeight: "160.5%",letterSpacing: "0.0875rem"}}>
                                                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                        <span>De:</span>
                                                                        <span>{dateRange.length > 0 ? moment(dateRange[0]).format("DD/MM/YY (ddd)") : '-'}</span>
                                                                    </div>
                                                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                        <span>Até:</span>
                                                                        <span>{dateRange.length > 0 ? moment(dateRange[1]).format("DD/MM/YY (ddd)") : '-'}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                                                                                    
                                                            <div className="flex-row justify-center align-items-center w100" style={{gap:"0.5rem",paddingBottom:"1rem",borderBottom:"1px solid #F8F8F8"}}>
                                                                <div style={{flex:1,textAlign:"left",color: "#475467",fontFamily: "Poppins",fontSize: "1.125rem",fontStyle: "normal",fontWeight: 400,lineHeight: "1.625rem",letterSpacing: "0.02875rem"}}>Diárias</div>
                                                                <div style={{flex:1.5,color: "#475467",textAlign: "right",fontSize: "0.9375rem",fontStyle: "normal",lineHeight: "1.625rem",letterSpacing: "0.02875rem"}}>{selectedProperty?.dateRangeDays || "carregando..."} noites</div>
                                                            </div>
                                                            
                                                            <div className="flex-row justify-center align-items-center w100" style={{gap:"0.5rem",paddingBottom:"1rem",borderBottom:"1px solid #F8F8F8"}}>
                                                                <div style={{flex:1,textAlign:"left",color: "#475467",fontFamily: "Poppins",fontSize: "1.125rem",fontStyle: "normal",fontWeight: 400,lineHeight: "1.625rem",letterSpacing: "0.02875rem"}}>Hospedes</div>
                                                                <div style={{flex:1.5,flexWrap:"nowrap",textAlign:"right",color: "#475467",fontFamily: "Poppins",fontSize: "0.875rem",fontStyle: "normal",fontWeight: 400,lineHeight: "160.5%",letterSpacing: "0.0875rem"}}>{selectedProperty?.hostsLabel || "carregando..."}</div>
                                                            </div>

                                                            <div className="flex-row justify-center align-items-center w100" style={{gap:"0.5rem",paddingBottom:"1rem",borderBottom:"1px solid #F8F8F8"}}>
                                                                <div style={{flex:1,textAlign:"left",color: "#475467",fontFamily: "Poppins",fontSize: "1.125rem",fontStyle: "normal",fontWeight: 400,lineHeight: "1.625rem",letterSpacing: "0.02875rem"}}>Quartos</div>
                                                                <div style={{flex:1.5,flexWrap:"nowrap",textAlign:"right",color: "#475467",fontFamily: "Poppins",fontSize: "0.875rem",fontStyle: "normal",fontWeight: 400,lineHeight: "160.5%",letterSpacing: "0.0875rem"}}>{selectedProperty?.roomsLabel || "carregando..."}</div>
                                                            </div>
                                                        

                                                        </div>
                                                    
                                                    </div>

                                                </div>

                                                {/*selectedProperty.room && selectedProperty.room.length > 0 &&
                                                <>
                                                
                                                    <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%",gap:"0.5rem"}}>
    

                                                        <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{padding:"0.5rem",gap:"0.5rem",width:"100%"}}>

                                                            <div className="flex-column justify-center align-items-right w100">

                                                                {currencyCollectedFeeAmount == "USD" &&
                                                                <>
                                                                    <div className="resultsCard_details__prices___dailyPrice w100" style={{color:" #00A3FF",fontFamily: "Poppins",fontSize: "1.5rem",fontStyle: "normal",fontWeight: 600,lineHeight: "2.12938rem",textAlign:"right"}}><span style={{fontSize: "0.9375rem"}}>Total </span> {formatNumberCurrency(totalAmount,exchangeRateInitials)}</div>	
                                                                </>
                                                                }	

                                                                {(currencyCollectedFeeAmount != "USD" && totalCollectedFeeAmount > 0) &&
                                                                <>
                                                                    <div className="resultsCard_details__prices___dailyPrice w100" style={{color:" #00A3FF",fontFamily: "Poppins",fontSize: "1.5rem",fontStyle: "normal",fontWeight: 600,lineHeight: "2.12938rem",textAlign:"right"}}><span style={{fontSize: "0.9375rem"}}>Total </span> {formatNumberCurrency(totalAmountPaidNow,exchangeRateInitials)} + <span style={{fontSize: "0.9375rem"}}>{formatNumberCurrency(totalCollectedFeeAmount,currencyCollectedFeeAmount)}</span>   </div>    
                                                                </>
                                                                }


                                                                <div className="resultsCard_details__prices___dailyPrice w100" style={{color: "#878787",fontFamily: "Titillium Web",fontSize: "0.85rem",fontStyle: "normal",fontWeight: 400,lineHeight: "1.625rem",letterSpacing: "0.02875rem",textAlign:"right"}}>inclui impostos e taxas</div>

                                                                <div className="resultsCard_details__prices___dailyPrice w100" style={{color:" #878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "2.12938rem",textAlign:"right",marginTop:"1rem"}}><span style={{fontSize: "0.85rem"}}>Pagar na reserva </span> {formatNumberCurrency(totalAmountPaidNow,exchangeRateInitials)}</div>       


                                                                {totalCollectedFeeAmount &&
                                                                    <>
                                                                    <div className="resultsCard_details__prices___dailyPrice w100" style={{color:" #878787",fontFamily: "Poppins",fontSize: "1rem",fontStyle: "normal",fontWeight: 400,lineHeight: "2.12938rem",textAlign:"right",marginTop:"1rem"}}><span style={{fontSize: "0.85rem"}}>Pagar na propriedade </span> {formatNumberCurrency(totalCollectedFeeAmount,currencyCollectedFeeAmount)}

                                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{color: "rgb(183 183 183)",lineHeight:"1rem",fontFamily: "Titillium Web",fontSize: "0.75rem",fontStyle: "normal",fontWeight: 600,letterSpacing: "0.02875rem",textAlign:"right"}}>Os impostos e/ou taxas a serem pagos na propriedade deverão ser pagos na moeda acima.</div>

                                                                    </div>
                                                                    </>
                                                                }                                                         

                                                                <div style={{marginTop:"1rem"}}>
                                                                    <ConfirmPopup />
                                                                    <Button label="Confirmar e finalizar reserva" rounded className="pT10 mR10 headerButton tColorWhite w100" onClick={(e) => {confirm(e)}} />
                                                                </div>	                                                            
                                                                
                                                            </div>   

                                                        </div>
                                                    
                                                    </div>

                                                

                                                </>
                                                */}                                                

                                                {selectedProperty.room && selectedProperty.room.length > 0 &&
                                                <>
                                                {/* TOTALS */}
                                                <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%", gap:"0.5rem"}}>

                                                    <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{padding:"0.5rem", gap:"0.5rem", width:"100%"}}>

                                                    <div className="flex-column justify-center align-items-right w100">

                                                        {/* Total */}
                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                        color: " #00A3FF",
                                                        fontFamily: "Poppins",
                                                        fontSize: "1.5rem",
                                                        fontStyle: "normal",
                                                        fontWeight: 600,
                                                        lineHeight: "2.12938rem",
                                                        textAlign: "right"
                                                        }}>
                                                        <span style={{fontSize: "0.9375rem"}}>Total </span>
                                                        {formatNumberCurrency(totalAmount, exchangeRateInitials)}
                                                        {nonUsdFees.length > 0 && nonUsdFees.map((fee, idx) => (
                                                            <span key={idx}> + {formatNumberCurrency(fee.total, fee.currency)}</span>
                                                        ))}
                                                        </div>

                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                        color: "#878787",
                                                        fontFamily: "Titillium Web",
                                                        fontSize: "0.85rem",
                                                        fontStyle: "normal",
                                                        fontWeight: 400,
                                                        lineHeight: "1.625rem",
                                                        letterSpacing: "0.02875rem",
                                                        textAlign: "right"
                                                        }}>
                                                        inclui impostos e taxas
                                                        </div>

                                                        {/* Pagar na reserva */}
                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                        color: "#878787",
                                                        fontFamily: "Poppins",
                                                        fontSize: "1rem",
                                                        fontStyle: "normal",
                                                        fontWeight: 400,
                                                        lineHeight: "2.12938rem",
                                                        textAlign: "right",
                                                        marginTop: "1rem"
                                                        }}>
                                                        <span style={{fontSize:"0.85rem"}}>Pagar na reserva </span>
                                                        {formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)}
                                                        </div>

                                                        {/* Pagar na propriedade */}
                                                        {collectedFeeDetails.length > 0 && (
                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                            color: "#878787",
                                                            fontFamily: "Poppins",
                                                            fontSize: "1rem",
                                                            fontStyle: "normal",
                                                            fontWeight: 400,
                                                            lineHeight: "2.12938rem",
                                                            textAlign: "right",
                                                            marginTop: "1rem"
                                                        }}>
                                                            <span style={{fontSize:"0.85rem"}}>Pagar na propriedade </span>
                                                            {collectedFeeDetails.map((fee, idx) => (
                                                            <span key={idx}>{idx > 0 ? " + " : ""}{formatNumberCurrency(fee.total, fee.currency)}</span>
                                                            ))}
                                                            <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                            color: "rgb(183 183 183)",
                                                            lineHeight: "1rem",
                                                            fontFamily: "Titillium Web",
                                                            fontSize: "0.75rem",
                                                            fontStyle: "normal",
                                                            fontWeight: 600,
                                                            letterSpacing: "0.02875rem",
                                                            textAlign: "right"
                                                            }}>
                                                            Os impostos e/ou taxas a serem pagos na propriedade deverão ser pagos na moeda acima.
                                                            </div>
                                                        </div>
                                                        )}

                                                        <div style={{marginTop:"1rem"}}>
                                                            <div className="flex-row align-items-center justify-content-start" style={{gap:"0.5rem"}}>
                                                                <Checkbox inputId="acceptTerm" disabled={saving} name="acceptTerm" value="sim" onChange={handleTermsChange} checked={acceptTerm} className="mR10" />
                                                                <label htmlFor="acceptTerm" className="tAlignL">Estou de acordo com os <Button label="termos e condições de uso" link style={{padding:"unset"}} onClick={() => setTermsModal(true)} /></label>
                                                            </div>
                                                        </div>

                                                        <div style={{marginTop:"1rem"}}>
                                                        <ConfirmPopup />
                                                        <Button
                                                            label="Confirmar e finalizar reserva"
                                                            rounded
                                                            className="pT10 mR10 headerButton tColorWhite w100"
                                                            onClick={(e) => {confirm(e)}}
                                                        />
                                                        </div>

                                                    </div>

                                                    </div>

                                                </div>
                                                </>
                                                }


                                            </>
                                            }

										</div>



                                        {/* BOX Baixar PDF da cotação */}
										<div className="filterOptions flex-row justify-center align-items-center applyPointer" style={{width:"100%",height:"5rem",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem",gap:"1rem"}} onClick={handleDownloadQuote}>

											<div className="quotationButtonLabel w100 tAlignL" > {loadingQuote ? "Baixando..." : "Baixar PDF da cotação"}</div>
 	
                                            <div>
                                                <Button 
                                                icon={<><img src={iconDownload} alt="Baixar PDF" /></>}
                                                style={{width:"3rem",height:"auto",background:"none",border:0}}
                                            /></div>

										</div>


                                        {/* BOX Enviar cotação por e-mail */}
										{/*<div className="filterOptions flex-row justify-center align-items-center" style={{width:"100%",height:"5rem",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem",gap:"1rem"}}>

											<div className="quotationButtonLabel w100 tAlignL">{loadingSendEmail ? "Enviando..." : "Enviar cotação por e-mail"}</div>
 	
                                            <div>
                                                <Button 
                                                icon={<><img src={iconSendEmail} alt="Enviar Cotação" /></>}
                                                style={{width:"3rem",height:"auto",background:"none",border:0}}
                                                onClick={handleSendEmailQuote}
                                            /></div>

										</div>*/}                                        




									</div>

						</div>


					</div>				
					
					</div>

				</div> 
			</div>

    </div>	

        <Toast ref={toast} position="bottom-center" />

		<AlertView
			alert={alert}
			setAlert={setAlert}
			alertTitle={alertTitle}
			alertBody={alertBody}	
			scrollBlock={false}				
		/>

        <ExpireView
                alertExpire={alertExpire}
                setAlertExpire={setAlertExpire}
                alertTitleExpire={alertTitleExpire}
                alertBodyExpire={alertBodyExpire}	
                alertActionExpire={alertActionExpire}	
                scrollBlock={false}				
        />	        

        <TermsView
            setTermsModal={setTermsModal}
            termsModal={termsModal}
            scrollBlock={true}
        />        


		{/* Contac Us Section */}
		<ContactUs />

		{/* About Us Section */}
		<AboutUs />
	
	</>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser,
  currentAgency:store.appReducer.currentAgency,

  searchType:store.orderReducer.searchType,
  searchParams:store.orderReducer.searchParams,
  searchResultStatus:store.orderReducer.searchResultStatus,
  searchResultRowsNumber:store.orderReducer.searchResultRowsNumber,
  searchResultToken:store.orderReducer.searchResultToken,
  searchResultCurrentPage:store.orderReducer.searchResultCurrentPage,
  searchResultLimit:store.orderReducer.searchResultLimit,
  searchLocation:store.orderReducer.searchLocation,
  searchResultObj:store.orderReducer.searchResultObj,
  searchCurrency:store.orderReducer.searchCurrency,
  exchangeRates:store.orderReducer.exchangeRates,
  selectedProperty:store.orderReducer.selectedProperty,
  currentBooking:store.orderReducer.currentBooking ,
  paymentConfirmed:store.orderReducer.paymentConfirmed
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions,...OrderActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(BookingDetails);	


